//Keys used as part of intl setup
export const APP_TITLE = 'app-title';
export const APP_DESCRIPTION = 'app-description';
export const LANDING_BRIEF = 'landing-brief';
export const LANDING_LANGUAGE_SELECTOR = 'landing-lang-select';
export const LANDING_COUNTRY_SELECTOR = 'landing-country-select';
export const LANDING_TERMS = 'landing-terms';
export const LANDING_TERMS_ERROR = 'landing-terms-error';
export const LANDING_CAPTCHA_ERROR = 'landing-captcha-error';
export const LANDING_TERMS_I_HAVE_READ = 'landing-terms-i-have-read';
export const LANDING_TERMS_THE_USE_DISCLOSURE = 'landing-terms-the-use-disclosure';
export const LANDING_TERMS_THE_TRANSFER_OF = 'landing-terms-the-transfer-of';
export const LANDING_TERMS_I_UNDERSTAND_THAT = 'landing-terms-i-understand-that';
//Buttons translations
export const BUTTON_PREV = 'button-prev';
export const BUTTON_NEXT = 'button-next';
export const BUTTON_SUBMIT = 'button-submit';

//Side bar translations
export const MENU_FEEDBACK_FORM = 'menu-form';
export const MENU_FEEDBACK_STATUS = 'menu-status';
export const MENU_FORM_INTAKE = 'form-intake';
export const MENU_FORM_EVENT_DETAILS = 'form-event-details';
export const MENU_FORM_PRODUCT_INFO = 'form-product-info';

//System Menu Translations
export const SYSTEM_FEEDBACK_FORM = 'system-feedback-form';
export const SYSTEM_FEEDBACK_STATUS = 'system-feedback-status';
export const SUBMIT_FEEDBACK = 'submit-feedback';
export const CHECK_SUBMITTED_FEEDBACK = 'check-submitted-feedback';
export const BTN_LAUNCH_FORM = 'btn-launch-form';
export const BTN_CHECK_STATUS = 'btn-check-status';

//Form Translations
export const FORM_TITLE = 'form-title';
export const FORM_SUB_TITLE = 'form-sub-title';
export const FORM_MANDATORY_FIELDS = 'form-mandatory-fields';

//Miscellaneous
export const SELECT_RESPONSE = 'select-response';

//Form Intake Translations
export const FUNCTION_ROLE = 'function-role';
export const CUSTOMER_ACCOUNT_NUMBER = 'customer-account-number';
export const ENTER_CUSTOMER_ACCOUNT = 'enter-customer-account';
export const HELP_CUSTOMER_ACCOUNT_NUMBER = 'help-customer-account-number';
export const EVENT_REPORTED = 'event-reported';
export const REFERENCE_NUMBER = 'reference-number';
export const ENTER_REFERENCE = 'enter-reference';
export const WHO_REPORTED_TO = 'who-reported-to';
export const WHO_WAS_NOTIFIED = 'who-was-notified';
export const ENTER_NAME = 'enter-name';
export const YOUR_NAME = 'your-name';
export const OCCUPATION = 'occupation';
export const PHONE_NUMBER = 'phone-number';
export const ENTER_PHONE_NUMBER = 'enter-phone-number';
export const ENTER_EMAIL = 'enter-email';
export const EMAIL_ADDRESS = 'email-address';
export const ENTER_ADDRESS = 'enter-address';
export const ENTER_NA_IF_UNKNOWN = 'enter-na-if-unknown';
export const FACILITY_HOSPITAL = 'facility-hospital';
export const ENTER_FACILITY = 'enter-facility';
export const ADDRESS_1 = 'address-1';
export const ADDRESS_2 = 'address-2';
export const CITY = 'city';
export const STATE = 'state';
export const POSTAL_CODE = 'postal-code';
export const COUNTRY = 'country';
export const END_USER_CUSTOMER = 'end-user-customer';
export const ADDITIONAL_CONTACT_PERSON = 'additional-contact-person';
export const ADDITIONAL_PHONE = 'additional-phone';
export const ADDITIONAL_EMAIL = 'additional-email';
export const ANOTHER_FACILITY_ADDRESS = 'another-facility-address';
export const ANOTHER_FACILITY_HOSPITAL = 'another-facility-hospital';
export const ANOTHER_ENTER_FACILITY = 'another-enter-facility'
export const ANOTHER_ADDRESS_1 = 'another-address-1'
export const ANOTHER_ADDRESS_2 = 'another-address-2'
export const ANOTHER_CITY = 'another-city'
export const ANOTHER_STATE = 'another-state'
export const ANOTHER_POSTAL_CODE = 'another-postal-code'
export const ANOTHER_COUNTRY = 'another-country'

//Form Product Information Translations
export const LOT_SERIAL_NUMBER = 'lot-serial-number';
export const ENTER_LOT_SERIAL_NUMBER = 'enter-lot-serial-number';
export const HELP_LOT_SERIAL_NUMBER = 'help-lot-serial-number';
export const PRODUCT_CODE = 'product-code';
export const ENTER_PRODUCT_CODE = 'enter-product-code';
export const HELP_PRODUCT_CODE = 'help-product-code';
export const NDC = 'ndcNo';
export const ENTER_NDC = 'enter-ndcNo';
export const UDI = 'udiNo';
export const ENTER_UDI = 'enter-udiNo';
export const PRODUCT_NAME = 'product-name';
export const ENTER_PRODUCT_NAME = 'enter-product-name';
export const HELP_PRODUCT_NAME = 'help-product-name';
export const BEST_DESCRIBES = 'best-describes';
export const QUANTITY_TO_SELECT = 'quantity-to-select';
export const ENTER_QUANTITY = 'Enter-quantity';
export const HELP_QUANTITY = 'help-quantity';
export const UNIT = 'Unit';
export const AVAILABLE_TO_RETURNED = 'available-to-returned';
export const PHOTOGRAPH_AVAILABLE = 'photograph-available';
export const HELP_PHOTOGRAPH_AVAILABLE = 'help-photograph-available';
export const UPLOAD_IMAGES = 'upload-images';
export const REPORTER_NAME = 'reporter-name';
export const REPORTER_FACILITY = 'reporter-facility';
export const REPORTER_OCCUPATION = 'reporter-occupation';
export const REPORTER_PHONE_NUMBER = 'reporter-phone-number';
export const REPORTER_EMAIL_ADDRESS = 'reporter-email-address';
export const EMPLOYEE_NAME = 'employee-name';
export const EMPLOYEE_PHONE_NUMBER = 'employee-phone-number';
export const EMPLOYEE_EMAIL_ADDRESS = 'employee-email-address';
export const RETURNING_FOR_INVESTIGATION = 'returning-for-investigation';
export const HELP_RETURNING_FOR_INVESTIGATION = 'help-returning-for-investigation';
export const UNUSED_VANTIVE_PRODUCT = 'unused-vantive-Product';
export const YOU_INDICATED_SAMPLES = 'You-indicated-samples';
export const SAMPLE_RETURN_KIT = 'sample-return-kit';
export const A_BOX_WITH_A_PREPAID_LABEL = 'a-box-with-a-prepaid-label';
export const SAME_AS_MY_ADDRESS = 'same-as-my-address';
export const OTHER_CONTACT_NAME = 'other-contact-name';
export const OTHER_CONTACT_OCCUPATION = 'other-contact-occupation';
export const OTHER_CONTACT_PHONE_NUMBER = 'other-contact-phone-number';
export const OTHER_CONTACT_EMAIL_ADDRESS = 'other-contact-email-address';
export const MANUFACTURED_BY_ANOTHER_COMPANY = 'manufactured-by-another-company';
export const CUSTOMER_EXPLICITLY_REQUEST = 'customer-explicitly-request';
export const EXPLICITLY_REQUEST_CREDIT = 'explicitly-request-credit';
export const FOOTER_CREDIT_CONTACT_CUSTOMER = 'footer-credit-contact-customer';
export const FOOTER_CREDIT_EMAIL_BOLD = 'footer-credit-email-bold';
export const FOOTER_CREDIT_PHONE_BOLD = 'footer-credit-phone-bold';
export const FOOTER_CREDIT_EXPEDITE_REQUEST = 'footer-credit-expedite-request';
export const PRODUCT_FROM_VANTIVE = 'product-from-vantive';
export const QUANTITY_REQUESTED_CREDIT = 'quantity-requested-credit';
export const ENTER_NUMBER = 'enter-number';
export const ENTER_OCCUPATION = 'enter-occupation';
export const LOT_QUANTITY_NUMBER = 'lot-quantity-number';
export const WHOLESALERS_NAME = "wholesalers-name";
export const PLACE_WHOLESALERS_NAME = "place-wholesalers-name";
export const ADD_PRODUCT_TO_THE_GRID = "add-product-to-the-grid";
export const SAVE = "Save";
export const CANCEL = "Cancel";
export const ADD_MORE_PRODUCTS = "add-more-products";
export const REPORTER_ADDRESS = "reporter-address";
export const ATTACHMENTS = "Attachments";


//Form Event Details Translations
export const DATE_OF_EVENT = "date-of-event";
export const DATE_OF_EVENT_MSG = "date-of-event-msg";
export const HELP_DATE_OF_EVENT = "help-date-of-event";
export const DATE_VANTIVE_EMPLOYEE = "date-vantive-employee";
export const DURING_WHAT_PROCESS = "during-what-process";
export const WAS_THE_PATIENT = "was-the-patient";
export const WERE_YOU_CONNECTED = "were-you-connected";
export const PROVIDE_ANY_ADDITIONAL = "provide-any-additional";
export const HELP_YOU_IDENTIFIED_MORE = "you-identified-more";
export const ENTER_DETAILS = "enter-details";
export const PROVIDE_ANY_ATTACHMENT = "provide-any-attachment";
export const WAS_NEGATIVE_MEDICAL = "was-negative-medical";
export const WAS_MEDICAL_INTERVENTION = "Was-medical-intervention";
export const PROVIDE_DETAILS = "provide-details";
export const REQUIRED_TREATMENT = "required-treatment";
export const ENTER_TREATMENT = "enter-treatment";
export const RELEVANT_TESTS = "relevant-tests";
export const HELP_RELEVANT_TESTS = "help-relevant-tests";
export const RELEVANT_MEDICAL_HISTORY = "relevant-medical-history";
export const ENTER_HISTORY = "enter-history";
export const PATIENT_NAME = "patients-name";
export const PATIENT_INITIALS = "patients-initials";
export const PATIENT_PHONE_NUMBER = "Patient-Phone-Number";
export const PATIENT_EMAIL_ADDRESS = "patient-email-address";
export const I_DO_NOT_WISH_TO_PROVIDE = "I-do-not-wish-to-provide";
export const PATIENT_ADDRESS = "patient-address";
export const SAME_ADDRESS = "same-address";
export const DRUG_BEING_USED = "drug-being-used";
export const PATIENT_IDENTIFIER = "patient-identifier";
export const PATIENT_AGE_OR_DOB = "patient-age-or-dob";
export const ENTER_PATIENT_AGE = "enter-patient-age";
export const PATIENT_GENDER = "patient-gender";
export const PATIENT_WEIGHT = "patient-weight";
export const ENTER_WEIGHT = "enter-weight";
export const PATIENT_WEIGHT_UNIT = "patient-weight-unit";
export const MY_NAME = "my-name";
export const ENTER_IN_YOUR_CONTACT = "enter-in-your-contact";
export const MY_PHONE_NUMBER = "my-phone-number";
export const MY_EMAIL_ADDRESS = "my-email-address";
export const MY_ADDRESS = "my-address";
export const NAME_OF_VANTIVE_DRUG = "name-of-vantive-drug";
export const ENTER_DRUG_NAME = "enter-drug-name";
export const PLEASE_PROVIDE_THE_NAME = "please-provide-the-name";
export const APPLY_TO_EACH_UNIT = "apply-to-each-unit";
export const SELECT_THE_COMPONENT = "select-the-component";
export const USE_THE_DIAGRAM = "use-the-diagram";
export const TYPE_OF_DAMAGE = "type-of-damage";
export const PLEASE_ENTER_VALUE = "please-enter-value";
export const WAS_THE_PRODUCT_KINKED = "was-the-product-kinked";
export const WERE_ANY_CLEANING = "were-any-cleaning";
export const WHAT_WAS_THE_DISINFECTANT = "what-was-the-disinfectant";
export const NOTE_VANTIVE_LABELING = "note-vantive-labeling";
export const SELECT_ALL_THAT_APPLY = "select-all-that-apply";
export const DID_FOLLOWING_OCCUR = "did-following-occur";
export const SELECT_THE_LOCATION = "select-the-location";
export const WAS_THE_PRODUCT_EXPOSED = "was-the-product-exposed";
export const HOW_LONG_TRANSFER = "how-long-transfer";
export const WAS_THERE_DIFFICULTY = "was-there-difficulty";
export const WAS_DEVICE_OR_TOOL = "was-device-or-tool";
export const DESCRIBE_HOW_PRODUCT = "describe-how-product";
export const DID_YOU_OBSERVE = "did-you-observe";
export const WERE_DIFFICULTIES_PUTTING = "were-difficulties-putting";
export const WAS_THE_TRANSFER = "was-the-transfer";
export const SELECT_TYPE_OF_FLOW = "select-type-of-flow";
export const WAS_ANYTHING_BLOCKING = "was-anything-blocking";
export const WAS_ANY_ALARM = "was-any-alarm";
export const SELECT_BEST_DESCRIBE = "select-best-describe";
export const WERE_THE_MINICAPS = "were the-minicaps";
export const WAS_THE_SPONGE_VISIBLE = "was-the-sponge-visible";
export const WHERE_PARTICULATE_MATTERFOREIGN = "where-particulate-matterforeign";
export const DESCRIBE_THE_EXACT_LOCATION = "describe-the-exact-location";
export const WAS_THE_PARTICULATE_MATTER = "was-the-particulate-matter";
export const DOES_THE_PARTICULATE_MATER = "does-the-particulate-mater";
export const WHAT_COMPONENT_DOES = "what-component-does";
export const SELECT_CONNECTION_ISSUE = "select-connection-issue";
export const WERE_ASSIST_DEVICES = "were-assist-devices";
export const WERE_ANY_DIFFICULTIES = "were-any-difficulties";
export const PROVIDE_PRODUCT_INFORMATION = "provide-product-information";
export const WERE_THE_SPIKE_LUER = "were-the-spike-luer";
export const VANTIVE_LABELING_STATES = "vantive-labeling-states";
export const WERE_PETS_OR_ANIMALS = "were-pets-or-animals";
export const VANTIVE_LABELING_CONTAMINATION = "vantive-labeling-contamination";
export const WERE_OTHER_ISSUES = "were-other-issues";
export const WAS_MINICAP_TWISTED = "was-minicap-twisted";
export const WERE_DIFFICULTIES_TRANSFER_SET = "were-difficulties-transfer-set";
export const DID_TRANSFER_SET_CONNECTORS = "did-transfer-set-connectors";
export const WHAT_WAS_THE_ALARM = "what-was-the-alarm";
export const WHERE_OBSERVED_DAMAGE = "where-observed-damage";
export const SELECT_THE_TYPE_OBSERVED = "select-the-type-observed";
export const DID_DAMAGE_CAUSE_LEAK = "did-damage-cause-leak";
export const WAS_THE_SHIPPING_CARTON = "was-the-shipping-carton";
export const SELECT_FLOW_ISSUE_OBSERVED = "select-flow-issue-observed";
export const HOW_LONG_WAS_STORAGE = "how-long-wasstorage";
export const WAS_THERE_AN_ADAPTER = "was-there-an-adapter";
export const NAME_AND_MODEL = "name-and-model";
export const NAME_VAPORIZER = "name-vaporizer";
export const WAS_VIAL_INVERTED = "was-vial-inverted";
export const WHAT_VIAL_USED = "what-vial-used";
export const DRUG_NAME_MANUFACTURER = "drug-name-manufacturer";
export const WERE_BREAK_FRANGIBLE = "were-break-the-frangible";
export const WAS_ALARM_ASSOCIATED = "was-alarm-associated";
export const WHAT_PART_DISCOLORED = "what-part-discolored";
export const DESCRIBE_DISCOLORATION = "describe-discoloration";
export const HOW_PRODUCT_STORED = "how-product-stored";
export const DOES_DISCOLORATION_APPEAR = "does-discoloration-appear";
export const WHICH_CHAMBER_DISCOLORED = "which-chamber-discolored";
export const WAS_PEEL_SEAL_INTERCHAMBER = "was-peel-seal-interchamber";
export const WAS_DISCOLORATION_NOTICED = "was-discoloration-noticed";
export const SELECT_SPECIFICALLY_DESCRIBES = "select-specifically-describes";
export const WHAT_DEVICE_HAD_ALARM = "what-device-had-alarm";
export const WHAT_MISSING_MISASSEMBLED = "what-missing-misassembled";
export const RECONSTITUTION_ISSUE = "reconstitution-issue";
export const WHAT_MEDICATION_SOLUTION = "what-medication-solution";
export const WHAT_VOLUME_MEDICATION = "what-volume-medication";
export const WHAT_DEVICES_RECONSTITUTION = "what-devices-econstitution";
export const WAS_PRODUCT_EXPOSED_HEAT = "was-product-exposed-heat";
export const DESCRIBE_EXPOSURE = "describe-exposure";
export const WHAT_USED_ACTIVATE_SOLUTION = "what-used-activate-solution";
export const WAS_DAMAGE_OBSERVED = "was-damage-observed";
export const DESCRIBE_THE_DAMAGE = "describe-the-damage";
export const APPROXIMATELY_SOLUTION_POWDER = "approximately-solution-powder";
export const WAS_LEAK_OBSERVED = "was-leak-observed";
export const WHAT_FEATUR_DIFFICULT_USE = "what-featur-difficult-use";
export const HOW_WAS_DIFFICULT_USE = "how-was-difficult-use";
export const WHERE_MATTER_FOREIGN = "where-matter-foreign";
export const DOES_PARTICULATE_MATTER = "does-particulate-matter";
export const DESCRIBE_EXACT_LOCATION = "describe-exact-location";
export const WAS_MATTER_FOREIGN = "was-matter-foreign";
export const WHEN_MATTER_FOREIGN = "when -matter-foreign";
export const PROVIDE_INFORMATION_MEDICATION = "provide-information-medication";
export const PRODUCT_NAME_CODE_NUMBER = "product-name-code-number";
export const DESCRIBE_SPIKING = "describe-spiking";
export const INCLUDE_NEEDLE = "include-needle";
export const WHAT_ADMINISTRATION_RECONSTITUTION = "what-administration-reconstitution";
export const INCLUDE_MANUFACTURER = "include-manufacturer";
export const WAS_MEDICATION_ADDITIVE = "was-medication-additive";
export const WHAT_MEDICATION_ADDITIVE = "what-medication-additive";
export const WHAT_STATE_OF_PRODUCT = "what-state-of-product";
export const AFTER_UNITS_SAT = "after-units-sat ";
export const DID_ATTEMPT_AGITATE = "did-attempt-agitate";
export const DID_PRECIPITATE_DISSOLVE = "did-precipitate-dissolve";
export const WHAT_STORAGE_TEMPERATURE = "what-storage-temperature";
export const PROVIDE_TEMPERATURE_LOCATION = "provide-temperature-location";
export const ARE_TEMPERATURE_LOGS = "are-temperature-logs";
export const LOGS_CAN_BE_ATTACHED = "logs-can-be-attached";
export const IS_THE_STORAGE_UNIT = "is-the-storage-unit";
export const HOW_PRODUCT_THAWED = "how-product-thawed";
export const WHAT_STORAGE_CONDITIONS = "what-storage-conditions";
export const WAS_ANY_DAMAGE = "was-any-damage";
export const MORE_SPECIFIC_INFORMATION = "more-specific-information";
export const WHAT_PURPOSE_INDICATION = "what-purpose-indication";
export const WHAT_ROUTE_ADMINISTRATION = "what-route-administration";
export const WHAT_DATE_ADMINISTRATION = "what-date-administration";
export const WHAT_DOSAGE_STRENGTH = "what-dosage-strength";
export const WAS_RECENT_PRESCRIPTION = "was-recent-prescription";
export const WHAT_WAS_STORAGE_TEMPERATURE = "what-was-storage-temperature";
export const WERE_ANY_ADJUSTMENTS = "were-any-adjustments";
export const SELECT_APPROPRIATE_DESCRIPTION = "select-appropriate-description";
export const SELECT_LABELING_ISSUE = "select-labeling-issue";
export const WAS_CONNECTION_SECURE = "was-connection-secure";
export const WAS_EXPIRED_PRODUCT = "was-expired-product";
export const WAS_COMPONENT_DAMAGED = "was-component-damaged";
export const WERE_ABNORMALITIES_DAMAGE = "were-abnormalities-damage";
export const WHAT_PURCHASE_ORDER_NUMBER = "what-purchase-order-number";
export const WHAT_DATE_OF_ADMINISTRATION = "what-date-of-administration";
export const WHAT_WAS_EXPIRATION_DATE = "what-was-expiration-date";
export const DESCRIBE_WAS_INCORRECT = "describe-was-incorrect";
export const WHAT_SCANNER_USED = "what-scanner-used";
export const WAS_OVERPOUCH_POUCH = "was-overpouch-pouch";
export const WHAT_BACKGROUND_COLOR = "what-background-color";
export const DO_ALL_OF_THE_LABELS = "do-all-of-the-labels";
export const PRODUCT_INFORMATION = "product-Information";
export const IS_A_BARCODE_SCANNER = "is-a-barcode-scanner";
export const HOW_ARE_THESE_PRODUCTS = "how-are these-products";
export const WHAT_INFORMATION_INCORRECTLY = "what-information-incorrectly";
export const WAS_THERE_LEAK = "was-there-leak";
export const WHERE_LEAK_OBSERVED = "where-leak-observed";
export const WAS_FRANGIBLE_OBSERVED = "was-frangible-observed";
export const IS_MOISTURE_CLEAR = "is-moisture-clear";
export const WHO_IS_YOUR_DISTRIBUTOR = "Who-is-your-distributor";
export const WHAT_MANUFACTURER_MEDICATION = "what-manufacturer-medication";
export const WHAT_GAUGE_NEEDLE = "what-gauge-needle";
export const WHAT_ADMINISTRATION_SET = "what-administration-set";
export const WAS_DIFFICULTY_SPIKING = "was-difficulty-spiking";
export const WERE_FOLLOWING_SCENARIOS = "were-following-scenarios";
export const WAS_FRANGIBLE_OBSERVED_DEFECT = "was-frangible-observed-defect";
export const WHAT_AMOUNT_PRESSURE = "what-amount-pressure";
export const WAS_BAG_COMPLETELY = "was-bag-completely";
export const WHAT_MANUFACTURER_MODEL = "what-manufacturer-model";
export const WHAT_PRESSURE_PRIOR = "what-pressure-prior";
export const LIST_THE_VAPORIZER = "list-the-vaporizer";
export const APPROXIMATELY_HOW_MUCH = "approximately-how-much";
export const WAS_THE_BOTTLE_DIFFICULT = "was-the-bottle-difficult";
export const WERE_VISIBLE_DEFECTS = "were-visible-defects";
export const SELECT_THE_OPTION = "select-the-option";
export const PROVIDE_INVOLVED_CONNECTION_ISSUE = "provide-involved-connection issue";
export const WHICH_PART_SEPARATED = "which-part-separated";
export const WHAT_COMPONENT_DISCOLORED = "what-component-discolored";
export const SELECT_DESCRIBES_DISCOLORATION = "select-describes-discoloration";
export const WAS_THE_SET_DISCOLORED = "was-the-set-discolored";
export const DID_SET_CHANGE_COLOR = "did-set-change-color";
export const WHAT_MEDICATION_ADDED = "what-medication-added";
export const WHERE_MATERIAL_LOCATED = "where-material-located";
export const DESCRIBE_APPEARANCE_COLOR_SIZE = "describe-appearance-color-size";
export const WAS_EMBEDDED_PLASTIC = "was-embedded-plastic";
export const WAS_THERE_A_PRECIPITATE = "was-there-a-precipitate";
export const WHAT_MEDICATIONS_SOLUTIONS = "what-medications-solutions";
export const WHERE_DAMAGE_COMPONENT_AFFECTED = "where-damage-component-affected";
export const WHAT_DAMAGE_ISSUE = "what-damage-issue";
export const DID_ISSUE_RESULT = "did-issue-result";
export const WAS_PATIENT_CONNECTED = "was-patient-connected";
export const WAS_PRODUCT_REPLACED = "was-product-replaced";
export const WHICH_SITUATION_BEST = "which-situation-best";
export const SELECT_MOST_LABELING_ISSUE = "select-most-labeling-issue";
export const WHAT_INFORMATION_DISPLAYED = "what-information-displayed";
export const WHAT_SCANNER_WAS_USED = "what-scanner-was-used";
export const INCLUDE_THE_MODEL_NAME = "include-the-model-name";
export const WAS_PRODUCT_ORDERED = "was-product-ordered";
export const DID_SCENARIOS_OCCURRED_LEAK = "did-scenarios-occurred-leak";
export const WHERE_LEAK_COMING = "where-leak-coming";
export const DID_ANY_OF_SCENARIOS = "did-any-of-scenarios";
export const WAS_POWER_INJECTOR = "was-power-injector";
export const WHAT_INJECTOR_USED = "what-injector-used";
export const MANUFACTURER_NAME_CODE_LOT = "manufacturer-name-code-lot";
export const DESCRIBE_INCORRECT_INCOMPLETE = "describe-incorrect-incomplete";
export const PROVIDE_INFORMATION_SECOND_PRODUCT = "provide-information-second-product";
export const WHICH_COMPONENTS_WERE_FOUND = "which-components-were-found";
export const DESCRIBE_CUT_HOLE_SLICE = "describe-cut-hole-slice";
export const WAS_LEAK_ORIGINATING = "was-leak-originating";
export const PROVIDE_DISCONNECTION_CONNECTION = "provide-disconnection-connection";
export const WHICH_SPECIFIC_BONDED = "which-specific-bonded";
export const WERE_VISIBLE_IRREGULARITIES = "were-visible-irregularities";
export const WAS_SUCCESSFUL_CONNECTION = "was-successful-connection";
export const WAS_TOOL_USED_ASSIST = "was-tool-used-assist";
export const WERE_LUER_CONNECTIONS = "were-luer-connections";
export const WAS_PRODUCT_SECURELY = "was-product-securely";
export const WHICH_DESCRIBES_FLOW_ISSUE = "which-describes-flow-issue";
export const WHAT_FLOWING_BACKWARDS = "what-flowing-backwards";
export const DESCRIBE_COMPONENTS_BACKFLOW = "describe components backflow";
export const DO_SITUATIONS_APPLY = "do-situations-apply";
export const WHICH_SPECIFIC_AREA = "which-specific-area";
export const WAS_FLOW_PREVIOUSLY_SEEN = "was-flow-previously-seen";
export const WAS_ANY_FOLLOWING_OBSERVED = "was-any-following-observed";
export const WHERE_SIMULTANEOUS_FLOW = "where-simultaneous-flow";
export const WHAT_TYPE_HANGER = "what-type-hanger";
export const WHAT_WAS_HANGER_LENGTH = "what-was-hanger-length";
export const WHICH_BAG_LOWER = "which-bag-lower";
export const WHAT_Y_SITE_WAS = "what-y-site-was";
export const WHAT_COMPONENT_WITHIN = "what-component-within";
export const WAS_COMPONENT_SET_REPLACED = "was-component-set-replaced";
export const WHAT_VOLUME_FLUID_PERIOD_TIME = "what-volume-fluid-period-time";
export const WHAT_VOLUME_FLUID_OVER_TIME = "what-volume-fluid-over-time";
export const WAS_USED_WITH_PUMP = "was-used-with-pump";
export const DID_CLAMP_FAIL = "did-clamp-fail";
export const WHAT_CLAMP_FAILED = "what-clamp-failed";
export const WAS_ISSUES_OBSERVED_CLAMP = "was-issues-observed-clamp";
export const DO_OTHER_SITUATIONS_DESCRIBE = "do-other-situations-describe";
export const DESCRIBE_ALARM_OBSERVED = "describe-alarm-observed";
export const INCLUDE_ANY_MESSAGES = "include-any-messages";
export const WHICH_CLAMP_HAD_ISSUE = "which-clamp-had-issue";
export const WHICH_TYPE_CLAMP_ISSUE = "which-type-clamp-issue";
export const SELECT_BEST_DESCRIBES_ISSUE = "select-best-descr-bes-issue";
export const PROVIDE_MORE_DETAILS = "provide-more-details";
export const PROVIDE_MORE_DETAILS_INSTRUCTIONS = "provide-more-details-instructions";
export const DESCRIBE_THE_SMELL = "describe-the-smell";
export const WAS_ISSUES_WITH_SET = "was-issues-with-set";
export const WHERE_LEAK_LOCATED = "where-leak-located";
export const DID_OCCUR_WITH_LEAK = "did-occur-with-leak";
export const PROVIDE_INVOLVED_DISCONNECTION = "provide-involved-disconnection";
export const DID_OCCURRED_WITH_THE_LEAK = "did-occurred-with-the-leak";
export const WHERE_WAS_PRODUCT_DAMAGED = "where-was-product-damaged";
export const SELECT_ALL_APPLY = "select all-apply";
export const DESCRIBE_OBSERVED_DAMAGE = "describe-observed-damage";
export const WHAT_COMPONENT_IS_DISCOLORED = "What-component-is discolored";
export const DESCRIBE_HUE_TINT_SHADE = "describe-hue-tint-shade";
export const INSIDE_OUTSIDE_OVERPOUCH = "inside-outside-overpouch";
export const DESCRIBE_EXACT_LOCATION_SIZE = "describe-exact-location-size";
export const DOES_THE_PARTICULATE_MATTER =  "does-the-particulate-matter";
export const WAS_PARTICULATE_MATERIAL_EMBEDDED = "was-particulate-material-embedded";
export const DOES_APPEAR_PRODUCT_MATERIAL = "does-appear product material";
export const WHERE_DID_THE_ISSUE_OCCUR = "where-did-the-issue-occur";
export const LIST_COMPONENTS_IF = "list components-If";
export const WERE_THERE_VISIBLE_IRREGULARITIES = "were-there-visible-irregularities";
export const SELECT_OPTION_FLOW_ISSUE = "select-option-flow-issue";
export const DESCRIBE_IRREGULARITIES = "describe-irregularities";
export const HOW_PRODUCT_SETUP = "how-product-setup";
export const SELECT_MOST_APPROPRIATE_DESCRIPTION = "select-most-appropriate-description";
export const DESCRIBE_WHAT_INCORRECT_INCOMPLETE = "describe-what-incorrect-incomplete";
export const WAS_SHIPPING_CARTON_DAMAGED = "was-shipping-carton-damaged";
export const WHAT_PRODUCT_WAS_SUPPOSED = "what-product-was-supposed";
export const IF_PRODUCT_CODE_NOT = "if-product-code-not";
export const WAS_THE_CASE_MISSING = "was-the-case-missing";
export const WHAT_CARRIER_DELIVERED = "what-carrier-delivered";
export const WHAT_IS_PURCHASE_ORDER_NUMBER = "what-is-purchase-order-number";
export const WHAT_QUANTITY_MISSING_UNITS = "what-quantity-missing-units";
export const WAS_EXPIRED_PRODUCT_USE = "was-expired-product-use";

//footer translations
export const COPYRIGHT = "copyright";
export const TERMS_CONDITIONS = "terms-conditions";
export const PRIVACY_POLICY = "privacy-policy";
export const PRIVACY_NOTICE = "privacy-notice";
export const COOKIE_POLICY = "cookie-policy";

//fildOptions translations
export const OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE = "functionoptions-vantive-employee";
export const OPTION_FUNCTIONOPTIONS_CAREGIVER = "functionoptions-caregiver";
export const OPTION_FUNCTIONOPTIONS_DISTRIBUTOR = "functionoptions-distributor";
export const OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL = "functionoptions-healthcare-professional";
export const OPTION_FUNCTIONOPTIONS_PATIENT = "functionoptions-patient";
export const OPTION_FUNCTIONOPTIONS_OTHER = "functionoptions-other";
export const OPTION_PROCESSSTEPOPTIONS_AFTER_USE = "processstepoptions-after-use";
export const OPTION_PROCESSSTEPOPTIONS_BEFORE_USE = "processstepoptions-before-use";
export const OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION = "processstepoptions-during-setup-preparation";
export const OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY = "processstepoptions-during-therapy";
export const OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS = "processstepoptions-multiple-steps";
export const OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED = "processstepoptions-not-specified";
export const OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER = "occupationoptions-family-member";
export const OPTION_OCCUPATIONOPTIONS_NURSE = "occupationoptions-nurse";
export const OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER = "occupationoptions-nurse-practitioner";
export const OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL = "occupationoptions-Other Health Care Professional";
export const OPTION_OCCUPATIONOPTIONS_PHYSICIAN = "occupationoptions-physician";
export const OPTION_UNITOPTIONS_BOXES = "unitoptions-boxes";
export const OPTION_UNITOPTIONS_PALLETS = "unitoptions-pallets";
export const OPTION_UNITOPTIONS_UNITS = "unitoptions-units";

export const OPTION_PROBLEMOPTIONS_ALARM_CONDITION = "problemoptions-alarm-condition";
export const OPTION_PROBLEMOPTIONS_DAMAGE = "problemoptions-damage";
export const OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE = "problemoptions-difficult-to-use";
export const OPTION_PROBLEMOPTIONS_DISCOLORED = "problemoptions-discolored";
export const OPTION_PROBLEMOPTIONS_FLOW_ISSUES = "problemoptions-flow-issues";
export const OPTION_PROBLEMOPTIONS_LABELING_ISSUES = "problemoptions-labeling-issues";
export const OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE = "problemoptions-leak-excessive-moisture";
export const OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL = "problemoptions-particulate-matter-foreign-material";
export const OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT = "problemoptions-patient-reaction-Adverse-event";
export const OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY = "problemoptions-product-inquiry";
export const OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION = "problemoptions-separation-connection";
export const OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT = "problemoptions-shipping-issues-expired-product";
export const OPTION_PATIENTSEXOPTIONS_FEMALE = "patientsexoptions-female";
export const OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE = "patientsexoptions-intersex";
export const OPTION_PATIENTSEXOPTIONS_MALE = "patientsexoptions-male";
export const OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER = "patientsexoptions-transgender";
export const OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN = "reporteroccupationoptions-asked-unknown";
export const OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR = "reporteroccupationoptions-administrator-supervisor";
export const OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER = "reporteroccupationoptions-biomedical-engineer";
export const OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE = "reporteroccupationoptions-company-representative";
export const OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST = "reporteroccupationoptions-reporteroccupationoptions-dentist";
export const OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR = "reporteroccupationoptions-reporteroccupationoptions-distributor";
export const OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER = "reporteroccupationoptions-reporteroccupationoptions-family membe";
export const OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER = "reporteroccupationoptions-lay-user";
export const OPTION_REPORTEROCCUPATIONOPTIONS_NURSE = "reporteroccupationoptions-nurse";
export const OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER = "reporteroccupationoptions-nurse-practitioner";
export const OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL = "reporteroccupationoptions-Other-health-care-professional";
export const OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST = "reporteroccupationoptions-pharmacist";
export const OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN = "reporteroccupationoptions-pharmacy-technician";
export const OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN = "reporteroccupationoptions-physician";
export const OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT = "reporteroccupationoptions-patient";
export const OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER = "reporteroccupationoptions-risk-manager";
export const OPTION_REPORTEROCCUPATIONOPTIONS_OTHER = "reporteroccupationoptions-other";
export const OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON = "productsurveillancecontactoptions-contact-additional-contact-person";
export const OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME = "productsurveillancecontactoptions-contact-me";
export const OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER = "productsurveillancecontactoptions-contact-other";
export const OPTION_REPORTEDTOOPTIONS_VANTIVE = "reportedtooptions-vantive";
export const OPTION_REPORTEDTOOPTIONS_CHINA_FDA = "reportedtooptions-china-fda";
export const OPTION_REPORTEDTOOPTIONS_EMA = "reportedtooptions-ema";
export const OPTION_REPORTEDTOOPTIONS_FDA = "reportedtooptions-fda";
export const OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA = "reportedtooptions-health-canada";
export const OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN = "reportedtooptions-pmda-japan";
export const OPTION_REPORTEDTOOPTIONS_TUV = "reportedtooptions-tuv";
export const OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA = "reportedtooptions-tga-australia";

export const OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL = "followingoccuroptions-a-pet-or-animal";
export const OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT = "followingoccuroptions-a-sharp-object";
export const OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED = "followingoccuroptions-the-product-problem-occurred";
export const OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT = "followingoccuroptions-the-product-cold-environment";
export const OPTION_DAMAGEMINICAPOPTIONS_CARTON = "damageminicapoptions-carton";
export const OPTION_DAMAGEMINICAPOPTIONS_MINICAP = "damageminicapoptions-minicap";
export const OPTION_DAMAGEMINICAPOPTIONS_POUCH = "damageminicapoptions-pouch";
export const OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT = "difficulttouseoptions-the-transfer-tight";
export const OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE = "difficulttouseoptions-the-transfer-loose";
export const OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE = "difficulttouseoptions-the-transfer-close";
export const OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN = "difficulttouseoptions-the-transfer-open";
export const OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN = "difficulttouseoptions-the-twist-clamp-open";
export const OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE = "difficulttouseoptions-the-twist-clamp-close";
export const OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE = "difficultiesminicapoptions-yes-there-was-damage";
export const OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP = "difficultiesminicapoptions-yes-the-minicap";
export const OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED = "flowissueoptions-completely-stopped";
export const OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY = "flowissueoptions-restricted-or-partially";
export const OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD = "blockingflowoptions-clotted-blood";
export const OPTION_BLOCKINGFLOWOPTIONS_FIBRIN = "blockingflowoptions-fibrin";
export const OPTION_BLOCKINGFLOWOPTIONS_KINK = "blockingflowoptions-kink";
export const OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE = "blockingflowoptions-particulate";
export const OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL = "blockingflowoptions-product-material";
export const OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE = "describeissueoptions-excess-iodine";
export const OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE = "describeissueoptions-excess-moisture";
export const OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH = "describeissueoptions-foil-pouch";
export const OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX = "describeissueoptions-package/box";
export const OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE = "describeissueoptions-sponge-dried-out-and-white";
export const OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR = "describeissueoptions-sponge-dried-out-brownish-color";
export const OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY = "materiallocatedoptions-in-the-secondary";
export const OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID = "materiallocatedoptions-inside-the-product-fluid";
export const OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING = "materiallocatedoptions-inside-the-shipping";
export const OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT = "materiallocatedoptions-on-the-outside-of-the-product";
export const OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH = "materiallocatedoptions-on-the-outside-of-overpouch";
export const OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR = "materiallocatedoptions-on-the-exterior";
export const OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING = "connectionissueoptions-difficulties-connecting";
export const OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING = "connectionissueoptions-difficulties-disconnecting";
export const OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS = "connectionissueoptions-separation-of-components";
export const OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION = "connectionissueoptions-separation-disconnection";
export const OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE = "residuethreadsoptions-yes-residue";
export const OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE = "residuethreadsoptions-yes-visible";
export const OPTION_RESIDUETHREADSOPTIONS_YES_OTHER = "residuethreadsoptions-yes-other";
export const OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE = "observeddamageoptions-frangible";
export const OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE = "observeddamageoptions-hanger-hole";
export const OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT = "observeddamageoptions-injection-filling-port";
export const OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT = "observeddamageoptions-membrane-Port";
export const OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH = "observeddamageoptions-overpouch-pouch";
export const OPTION_OBSERVEDDAMAGEOPTIONS_PATCH = "observeddamageoptions-patch";
export const OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER = "observeddamageoptions-rubber-stopper";
export const OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON = "observeddamageoptions-shipping-carton";
export const OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND = "observeddamageoptions-shrinkband";
export const OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER = "observeddamageoptions-solution-container";
export const OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR = "observeddamageoptions-tip-protector";
export const OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL = "observeddamageoptions-tamper-evident-seal";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT = "typeobserveddamageoptions-bent";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN = "typeobserveddamageoptions-broken";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED = "typeobserveddamageoptions-cracked";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT = "typeobserveddamageoptions-cut";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED = "typeobserveddamageoptions-deformed";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING = "typeobserveddamageoptions-flaking";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE = "typeobserveddamageoptions-hole";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED = "typeobserveddamageoptions-kinked";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED = "typeobserveddamageoptions-melted";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION = "typeobserveddamageoptions-patch-layer-separation";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS = "typeobserveddamageoptions-shattered-glass";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED = "typeobserveddamageoptions-sliced";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN = "typeobserveddamageoptions-torn";
export const OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW = "flowissueobservedoptions-solution-would-not-flow";
export const OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW = "flowissueobservedoptions-solution-would-flow";
export const OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING = "flowissueobservedoptions-solution-would-compounding";

export const OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE = "productdiscoloredoptions-bottle";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER = "productdiscoloredoptions-container";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE = "productdiscoloredoptions-hanger-hole";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_LINER = "productdiscoloredoptions-liner";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH = "productdiscoloredoptions-overpouch-pouch";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR = "productdiscoloredoptions-oxygen-indicator";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH = "productdiscoloredoptions-patch";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS = "productdiscoloredoptions-ports";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION = "productdiscoloredoptions-solution";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR = "productdiscoloredoptions-tip-protector";
export const OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER = "chamberdiscoloredoptions-amino-acid-chamber";
export const OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER = "chamberdiscoloredoptions-dextrose-chamber";
export const OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER = "chamberdiscoloredoptions-lipid-chamber";
export const OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER = "chamberdiscoloredoptions-lower-chamber";
export const OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER = "chamberdiscoloredoptions-upper-chamber";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL = "specificallydescribesoptions-burst-ruptured-seal";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART = "specificallydescribesoptions-misassembled-product-part";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT = "specificallydescribesoptions-missing-component";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF = "whattypedamageissueoptions-separation-disconnection-of";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED = "specificallydescribesoptions-product-over-filled";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED = "specificallydescribesoptions-product-under-filled";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION = "specificallydescribesoptions-reconstitution";

export const OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY = "matterforeignmaterialoptions-In-the-secondary";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION = "matterforeignmaterialoptions-Inside-solution-fluid";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING = "matterforeignmaterialoptions-Inside-the-shipping";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER = "matterforeignmaterialoptions-Inside-the-vaporizer";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE = "matterforeignmaterialoptions-On-external-surface";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE = "matterforeignmaterialoptions-On-the-outside";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR = "matterforeignmaterialoptions-On-the-exterior";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN = "matterforeignmaterialoptions-On-the-Oxygen-absorber";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL = "matterforeignmaterialoptions-On-the-Transdermal";
export const OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER = "matterforeignmaterialoptions-Other";


export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE = "matterforeignmaterialpiecesoptions-frangible";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES = "matterforeignmaterialpiecesoptions-glass-particles";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT = "matterforeignmaterialpiecesoptions-port";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER = "matterforeignmaterialpiecesoptions-rubber-stopper";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING = "matterforeignmaterialpiecesoptions-tubing";
export const OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER = "whenmaterialobservedoptions-after-adding-another";
export const OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING = "whenmaterialobservedoptions-prior-to-spiking";
export const OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED = "cloudinessobservedoptions-cold-thawed";
export const OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN = "cloudinessobservedoptions-frozen";
export const OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED = "cloudinessobservedoptions-partially-thawed";
export const OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE = "cloudinessobservedoptions-room-temperature";

export const OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING = "productthawedoptions-vantive-thawing";
export const OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER = "productthawedoptions-left-on-counter";
export const OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR = "productthawedoptions-refrigerator";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE = "damageissueobservedoptions-yes-evidence";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED = "damageissueobservedoptions-yes-leak-observed";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE = "damageissueobservedoptions-yes-hole-or-incomplete";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING = "damageissueobservedoptions-yes-difficulty-spiking";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING = "damageissueobservedoptions-yes-difficulty-breaking";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION = "damageissueobservedoptions-yes-there-was-crystallization";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS = "damageissueobservedoptions-Yes-there-was-cloudiness";
export const OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT = "damagespecificinfooptions-product-did-not";
export const OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT = "damagespecificinfooptions-unintended-effect";
export const OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING = "damaged shipping";
export const OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED = "appropriatedescriptionoptions-expired-product-delivered";
export const OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND = "appropriatedescriptionoptions-expired-product-found";
export const OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE = "labelingissueoptions-barcode-issue";
export const OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING = "labelingissueoptions-difficulties-scanning";

export const OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED = "labelingissueoptions-expired-product-delivered";

export const OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY = "labelingissueoptions-expired-product-inventory";
export const OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL = "labelingissueoptions-illegible-label";
export const OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL = "labelingissueoptions-incorrect-label";
export const OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL = "labelingissueoptions-incomplete-label";
export const OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR = "labelingissueoptions-label-too-similar";
export const OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT = "labelingissueoptions-labels-product";
export const OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE = "labelingissueoptions-missing-barcode";


export const OPTION_DESCOFISSUEOPTIONS_CARTON_BOX = "descofissueoptions-carton-box";
export const OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING = "descofissueoptions-damaged-shipping";
export const OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED = "descofissueoptions-extra-units-were-received";
export const OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED = "descofissueoptions-expired-product-delivered";
export const OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND = "descofissueoptions-expired-product-found";
export const OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON = "descofissueoptions-part-of-the-carton";
export const OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON = "descofissueoptions-product-information-on-the-carton";
export const OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING = "descofissueoptions-units-were-missing";
export const OPTION_DESCOFISSUEOPTIONS_OTHER = "descofissueoptions-other";


export const OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL = "labelingissueoptions-missing-label";
export const OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE = "whatincorrectlydisplayedoptions-expiration-date";
export const OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER = "whatincorrectlydisplayedoptions-lot-number";
export const OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER = "whatincorrectlydisplayedoptions-ndcNo-number";
export const OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE = 'whatincorrectlydisplayedoptions-product-code';
export const OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE = "moistureobservedoptions-droplets-moisture";
export const OPTION_MOISTUREOBSERVEDOPTIONS_LEAK = "moistureobservedoptions-leak";
export const OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED = "moistureobservedoptions-leak-observed";
export const OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING = "moistureobservedoptions-solution-flowing";
export const OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE = "moistureobservedoptions-solution-inside";
export const OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH = "componentleakingoptions-between-overpouch";
export const OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN = "componentleakingoptions-connection-between";
export const OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE = "componentleakingoptions-container-membrane";
export const OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION = "componentleakingoptions-container-injection";

export const OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER = "componentleakingoptions-container-hanger Hole";
export const OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER = "componentleakingoptions-Container";
export const OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE = "componentleakingoptions-Frangible";
export const OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER = "componentleakingoptions-Rubber Stopper";
export const OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND = "componentleakingoptions-Shrinkband";
export const OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR = "componentleakingoptions-Tip Protector";
export const OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN = "componentleakingoptions-Unknown";
export const OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER = "componentleakingoptions-vial-adapter";


export const OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT = "scenariosleakoptions-adhered-port";
export const OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES = "scenariosleakoptions-damage-holes";
export const OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME = "scenariosleakoptions-exposure-to-extreme";
export const OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER = "scenariosleakoptions-leak-at-vaporizer";
export const OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING = "scenariosleakoptions-opening-shipping";
export const OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED = "scenariosleakoptions-pets-clawed";
export const OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER = "scenariosleakoptions-solution-bag-under";

export const OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT = "scenarioswithleakoptions-adhered-port";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES = "scenarioswithleakoptions-damage-holes-tears";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING = "scenarioswithleakoptions-damaged-shipping";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME = "scenarioswithleakoptions-exposure-to-extreme";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER = "scenarioswithleakoptions-leak-at-vaporizer";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING = "scenarioswithleakoptions-opening-shipping";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED = "scenarioswithleakoptions-pets-clawed-chewed";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER = "scenarioswithleakoptions-solution-bag";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN = "scenarioswithleakoptions-unknown";
export const OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE = "scenarioswithleakoptions-none-of-the-above";


export const NO_DESCRIBE_THE_COLOR = "no-describe-the-color";

export const OPTION_LIQUIDSPILLEDOPTIONS_ML = "liquidspilledoptions-ml";
export const OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML = "liquidspilledoptions-greater-than-ml";
export const OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML = "liquidspilledoptions-less-than-ml";
export const OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE = "visibledefectsoptions-bottle";
export const OPTION_VISIBLEDEFECTSOPTIONS_CAP = "visibledefectsoptions-cap";
export const OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK = "visibledefectsoptions-valve-neck";
export const OPTION_VISIBLEDEFECTSOPTIONS_NONE = "visibledefectsoptions-none";

export const OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING = "optionconnectionissueoptions-difficulties-connecting";
export const OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING = "optionconnectionissueoptions-difficulties-disconnecting";
export const OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS = "optionconnectionissueoptions-separation-of-components";
export const OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION = "optionconnectionissueoptions-separation-disconnection-of";



export const OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER = "whatcomponentdiscoloredoptions-drip-chamber";
export const OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING = "whatcomponentdiscoloredoptions-tubing";
export const OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN = "whatcomponentdiscoloredoptions-unknown";
export const OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY = "whatcomponentdiscoloredoptions-other-Please specify";


export const OTHER_PLEASE_SPECIFY = "other-please-specify";
export const OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY = "describesdiscolorationoptions-white-cloudy";
export const OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY = "describesdiscolorationoptions-other-please specify";
export const OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH = "describesdiscolorationoptions-yellow-brownish";
export const OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING = "wherematterlocatedoptions-in-the-primary-packaging";
export const OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV = "wherematterlocatedoptions-inside-the-iv";

export const OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING = "wherematterlocatedoptions-inside-the-shipping";
export const OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR = "wherematterlocatedoptions-on-the-exterior";
export const OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV = "wherematterlocatedoptions-outside-the-iv";

export const OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED = "embeddedplasticoptions-embedded";
export const OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE = "embeddedplasticoptions-loose";
export const OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE = "embeddedplasticoptions-not-applicable";
export const OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR = "infusatesolutionoptions-describe-color";
export const OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR = "infusatesolutionoptions-yes-Change-in-color";
export const OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE = "infusatesolutionoptions-yes-precipitate";
export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE = "damagecomponentaffectedoptions-access-site";
export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES = "damagecomponentaffectedoptions-burrettes";

export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP = "damagecomponentaffectedoptions-clamp";

export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER = "damagecomponentaffectedoptions-drip-chamber";
export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS = "damagecomponentaffectedoptions-filters";
export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR = "damagecomponentaffectedoptions-luer-connector";
export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE = "damagecomponentaffectedoptions-spike";
export const OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING = "damagecomponentaffectedoptions-tubing";
export const DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN = "unknown";
export const DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER = "other";

export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN = "whattypedamageissueoptions-cut-cracked-broken";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY = "whattypedamageissueoptions-incorrect-component-assembly";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED = "whattypedamageissueoptions-kinked-collapsed";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT = "whattypedamageissueoptions-loose-component";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED = "whattypedamageissueoptions-malformed-mis-shaped";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT = "whattypedamageissueoptions-missing-component";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE = "situationdescribesissueoptions-difficulty-connecting-the";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE = "situationdescribesissueoptions-difficulty-disconnecting-the";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION = "situationdescribesissueoptions-loose-connection";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION = "situationdescribesissueoptions-Separation/disconnection of the product from another product";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO = "situationdescribesissueoptions-separation-between-two";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT = "situationdescribesissueoptions-unable-to-connect";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT = "situationdescribesissueoptions-unable-to-disconnect";
export const CHANGE_IN_LABELING = "change-in-labeling";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT = "descriptionlabelingissueoptions-expired-product";

export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE = "descriptionlabelingissueoptions-barcode-issue";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING = "descriptionlabelingissueoptions-change-in-labeling";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING = "descriptionlabelingissueoptions-difficulties-scanning";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER = "descriptionlabelingissueoptions-other";

export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL = "descriptionlabelingissueoptions-incorrect-information-on-label";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI = "descriptionlabelingissueoptions-missing-barcode-udiNo";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL = "descriptionlabelingissueoptions-missing-information-on-label";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION = "descriptionlabelingissueoptions-product-with-no-expiration";
export const OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING = "descriptionlabelingissueoptions-smudges-illegible-labeling";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX = "appropriatedescissueoptions-carton-box";

export const OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING = "appropriatedescissueoptions-damagedshipping";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED = "appropriatedescissueoptions-expired-product-delivered";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND = "appropriatedescissueoptions-expired-product-found";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER = "appropriatedescissueoptions-other";

export const OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE = "orderedfromvantiveoptions-vantive";
export const OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR = "orderedfromvantiveoptions-distributor";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED = "appropriatedescissueoptions-extra-units-were-received";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON = "appropriatedescissueoptions-part-of-the-carton";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON = "appropriatedescissueoptions-product-info-on-the-carton";
export const OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING = "appropriatedescissueoptions-units-were-missing";
export const OPTION_ORDEREDFROMVANTIVEOPTIONS_CLEARLINK_INJECTION_SITES = "orderedfromvantiveoptions-clearlink-injection-sites";
export const OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE = "leakcomingfromoptions-access-site";
export const OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT = "leakcomingfromoptions-air-vent";
export const OPTION_LEAKCOMINGFROMOPTIONS_BURETTES = "leakcomingfromoptions-burettes";
export const OPTION_LEAKCOMINGFROMOPTIONS_CAP = "leakcomingfromoptions-cap";
export const OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES = "leakcomingfromoptions-clearlink-injection-sites";
export const OPTION_LEAKCOMINGFROMOPTIONS_CLAMP = "leakcomingfromoptions-clamp";
export const OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER = "leakcomingfromoptions-drip-chamber";
export const OPTION_LEAKCOMINGFROMOPTIONS_FILTERS = "leakcomingfromoptions-filters";
export const OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES = "leakcomingfromoptions-interlink-injection-sites";
export const OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR = "leakcomingfromoptions-luer-connector";
export const OPTION_LEAKCOMINGFROMOPTIONS_SPIKE = "leakcomingfromoptions-spike";
export const OPTION_LEAKCOMINGFROMOPTIONS_TUBING = "leakcomingfromoptions-tubing";
export const OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN = "leakcomingfromoptions-unknown";
export const OPTION_LEAKCOMINGFROMOPTIONS_OTHER = "leakcomingfromoptions-other";

export const OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE = "leakcomingfromoptions-leak-between-the";
export const OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED = "leakcomingfromoptions-needle-Based";
export const OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION = "leakcomingfromoptions-one-Link-injection";
export const OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION = "leakcomingfromoptions-other-injection";
export const OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN = "followingscenariosoptions-crack-break-in";
export const OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN = "followingscenariosoptions-cut-slice-in";
export const DISCONNECTION_OF_CONNECTABLE = "disconnection-of-connectable";
export const OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE = "followingscenariosoptions-disconnection-of-connectable";
export const OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS = "followingscenariosoptions-separation-of-bonded-components";
export const OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES = "visibleirregularitiesoptions-yes-describe-irregularities";
export const YES_SPECIFY_THE_TOOL = "yes-specify-the-tool";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW = "situationflowissueoptions-backflow";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT = "situationflowissueoptions-clamp-failure-difficult";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE = "situationflowissueoptions-clamp-failure-unable";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE = "situationflowissueoptions-clamp-failure-difficult-unable";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW = "situationflowissueoptions-no-flow";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION = "situationflowissueoptions-over-infusion";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW = "situationflowissueoptions-restricted-slow";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW = "situationflowissueoptions-simultaneous-flow";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR = "situationflowissueoptions-unable-to-clear";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME = "situationflowissueoptions-Unable-to-prime";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION = "situationflowissueoptions-under-infusion";
export const OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD = "flowingbackwardsoptions-patients-blood";
export const OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD = "flowingbackwardsoptions-solutions-blood";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE = "situationsapplyeventoptions-damage-hole";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION = "situationsapplyeventoptions-disconnection";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK = "situationsapplyeventoptions-leak";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING = "situationsapplyeventoptions-medication-was-being";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER = "situationsapplyeventoptions-secondary-bag-was-lower";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT = "situationsapplyeventoptions-secondary-bag-was-at";
export const SEPARATION = "separation";
export const OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING = "previouslyflowobservedoptions-blood-clotting";
export const OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS = "previouslyflowobservedoptions-catheter-was";
export const OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING = "previouslyflowobservedoptions-kinked-tubing";
export const OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION = "previouslyflowobservedoptions-tubing-injection";
export const OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY = "simultaneousflowoptions-primary-and-secondary";
export const OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS = "simultaneousflowoptions-two-or-more-leads";
export const OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION = "simultaneousflowoptions-two-administration";
export const OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER = "hangerusedoptions-vantive-hanger";
export const OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER = "hangerusedoptions-non-vantive-Hanger";
export const OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT = "bagloweroptions-bags-were-at";
export const OPTION_BAGLOWEROPTIONS_PRIMARY = "bagloweroptions-primary";
export const OPTION_BAGLOWEROPTIONS_SECONDARY = "bagloweroptions-secondary";
export const OPTION_YSITECONNECTEDOPTIONS_MIDDLE = "ysiteconnectedoptions-middle";
export const OPTION_YSITECONNECTEDOPTIONS_LOWER = "ysiteconnectedoptions-lower";
export const OPTION_YSITECONNECTEDOPTIONS_UPPER = "ysiteconnectedoptions-upper";
export const OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME = "withpumpoptions-yes-provide-name";

export const OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE = "whatClampFailedOptions-dark-blue";
export const OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE = "whatClampFailedOptions-light-blue";
export const OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP = "whatClampFailedOptions-notch-clamp";
export const OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP = "whatClampFailedOptions-roller-clamp";
export const OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP = "white-slide-clamp";
export const OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP = "issuesObservedClampOptions-yes-the-clamp";
export const OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE = "otherSituationsProductOptions-air-in-Line";
export const OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE = "otherSituationsProductOptions-clamp-issue";
export const OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR = "otherSituationsProductOptions-odor";
export const OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER = "otherSituationsProductOptions-other";
export const OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH = "whichClampIssueOptions-notch-pinch";
export const OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP = "whichClampIssueOptions-roler-clamp";
export const OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP = "whichClampIssueOptions-slide-clamp";
export const OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN = "whichClampIssueOptions-unknown";
export const OPTION_WHICHCLAMPISSUEOPTIONS_OTHER = "whichClampIssueOptions-other";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN = "clampIssueExperiencedOptions_cracked-broken";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN = "clampIssueExperiencedOptions-cracked-broken";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN = "clampIssueExperiencedOptions-difficult-to-open";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE = "clampIssueExperiencedOptions-difficult-to-close";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING = "clampIssueExperiencedOptions-missing";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN = "clampIssueExperiencedOptions-unable-to-open";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE = "clampIssueExperiencedOptions-unable-to-close";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL = "clampIssueExperiencedOptions-unable-to-control";
export const OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE = "clampDescribesIssueOptions-difficult-to-squeeze";
export const OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE = "clampDescribesIssueOptions-instructions-were";
export const OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT = "clampDescribesIssueOptions-product-was-difficult";
export const OPTION_LEAKOCCUROPTIONS_CRACK_BREAK = "leakOccurOptions-crack-break";
export const OPTION_LEAKOCCUROPTIONS_CUT_SLICE = "leakOccurOptions-cut-slice";
export const OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE = "leakoccuroptions-disconnection-of-connectable";
export const OPTION_LEAKOCCUROPTIONS_HOLE_TEA = "leakOccurOptions-hole-tea";
export const OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED = "leakOccurOptions-separation-of-bonded";
export const OPTION_LEAKOCCUROPTIONS_OTHER = "leakOccurOptions-other";

export const OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT = "leakscenariosoptions-Adhered-Port";
export const OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES = "leakscenariosoptions-Damage-holes";
export const OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON = "leakscenariosoptions-Damaged-shipping-carton";
export const OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME = "leakscenariosoptions-Exposure-to-extreme";
export const OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING = "leakscenariosoptions-Opening-shipping";
export const OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN = "leakscenariosoptions-unknown";
export const OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE = "leakscenariosoptions-None-of-the-above";

export const OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF = "leakScenariosOptions-pressure-cuff";
export const OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED = "leakScenariosOptions-pets-clawed-chewed";
export const OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT = "productDamagedOptions-product";
export const OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX = "productDamagedOptions-shipping-carton-box";
export const OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT = "inside-the-product";

export const OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING = "matterforeignlocatedoptions-inside-the-shipping-carton";
export const OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT = "matterforeignlocatedoptions-on-the-outside-of-the-product";
export const OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR = "matterforeignlocatedoptions-on-the-exterior";

export const OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF = "matterForeignLocatedOptions-on-the-inside-of";
export const OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF = "matterForeignLocatedOptions-on-the-outside-of";

export const OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING = "seloptionconnectionissueoptions-difficulties-connecting";
export const OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING = "seloptionconnectionissueoptions-difficulties-disconnecting";
export const OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION = "seloptionconnectionissueoptions-loose-connection";
export const OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS = "seloptionconnectionissueoptions-separation-of-components";
export const OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION = "seloptionconnectionissueoptions-separation-disconnection";


export const OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING = "optionFlowIssueOptions-not-flowing";
export const OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR = "optionFlowIssueOptions-restricted-or";
export const OPTION_OPTIONFLOWISSUEOPTIONS_OTHER = "optionFlowIssueOptions-other";

export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE = "mostapprolabelingissueoptions-barcode_issue";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING = "mostapprolabelingissueoptions-difficulties-scanning";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL = "mostapprolabelingissueoptions-illegible-label";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL = "mostapprolabelingissueoptions-incorrect-label";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL = "mostapprolabelingissueoptions-incomplete-label";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT = "mostapprolabelingissueoptions-labels-product";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR = "mostapprolabelingissueoptions-label-too-similar";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL = "mostapprolabelingissueoptions-missing-label";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE = "mostapprolabelingissueoptions-missing-barcode";
export const OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER = "mostapprolabelingissueoptions-other";

export const OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT = "descOfIssueOptions-descOfIssueOptions-frozen-product";
export const OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT = "descOfIssueOptions-thawed-product";
export const OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN = "alarmOptions-yes-alarm-not-known";
export const OPTION_ALARMOPTIONS_YES_SPECIFY = "yes-specify";
export const OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN = "difficultInTwistClampOptions-yes-the-transfer-fully-open";
export const OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED = "difficultInTwistClampOptions-yes-the-twist-fully-closed";
export const OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL = "difficultInTwistClampOptions-yes-the-transfer-open-at-all";
export const OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL = "difficultInTwistClampOptions-yes-the-transfer-close-at-all";
export const OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH = "componentHadIssueOptions-box-or-overpouch";
export const OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON = "componentHadIssueOptions-blue-Clamp-on";
export const OPTION_COMPONENTHADISSUEOPTIONS_CASSETT = "componentHadIssueOptions-cassett";
export const OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE = "componentHadIssueOptions-drain-line";
export const OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE = "componentHadIssueOptions-effluent-sample";
export const OPTION_COMPONENTHADISSUEOPTIONS_LINES = "componentHadIssueOptions-lines";
export const OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE = "componentHadIssueOptions-luer-spike";
export const OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER = "componentHadIssueOptions-organizer";
export const OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE = "componentHadIssueOptions-pull-ring-patient-line";
export const OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS = "componentHadIssueOptions-pull-ring-protectors";
export const OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON = "componentHadIssueOptions-red-clamp-on";
export const OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD = "componentHadIssueOptions-tack-weld";
export const OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY = "componentHadIssueOptions-white-clamp-on-supply";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER = "selectComponentHadIssueOptions-beige-catheter";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT = "selectComponentHadIssueOptions-chip-insert";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR = "selectComponentHadIssueOptions-dark-blue-connector";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN = "selectComponentHadIssueOptions-light-blue-main";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL = "selectComponentHadIssueOptions-light-blue-pull";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER = "selectComponentHadIssueOptions-light-blue-occluder";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING = "selectComponentHadIssueOptions-silicone-tubing";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE = "selectComponentHadIssueOptions-titanium-spike";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE = "selectComponentHadIssueOptions-uv-flash-spike";
export const OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP = "selectComponentHadIssueOptions-white-twist-clamp";
export const OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE = "anyComponentDamagedOptions-yes-describe-the-damage";
export const OPTION_MONTHOPTIONS_JAN = "monthoptions-jan";
export const OPTION_MONTHOPTIONS_FEB = "monthoptions-feb";
export const OPTION_MONTHOPTIONS_MAR = "monthoptions-mar";
export const OPTION_MONTHOPTIONS_APR = "monthoptions-apr";
export const OPTION_MONTHOPTIONS_MAY = "monthoptions-may";
export const OPTION_MONTHOPTIONS_JUN = "monthoptions-jun";
export const OPTION_MONTHOPTIONS_JUL = "monthoptions-jul";
export const OPTION_MONTHOPTIONS_AUG = "monthoptions-aug";
export const OPTION_MONTHOPTIONS_SEP = "monthoptions-sep";
export const OPTION_MONTHOPTIONS_OCT = "monthoptions-oct";
export const OPTION_MONTHOPTIONS_NOV = "monthoptions-nov";
export const OPTION_MONTHOPTIONS_DEC = "monthoptions-dec";

export const OPTION_PROBLEMOPTIONS_OTHER = "problemoptions-other";
export const OPTION_REPORTEDTOOPTIONS_OTHER = "reportedtooptions-other";
export const OPTION_DIFFICULTTOUSEOPTIONS_OTHER = "difficulttouseoptions-other";
export const OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER = "difficultiesminicapoptions-other";
export const OPTION_BLOCKINGFLOWOPTIONS_OTHER = "blockingflowoptions-other";
export const OPTION_DESCRIBEISSUEOPTIONS_OTHER = "describeissueoptions-other";
export const OPTION_MATERIALLOCATEDOPTIONS_OTHER = "materiallocatedoptions-other";
export const OPTION_OBSERVEDDAMAGEOPTIONS_OTHER = "observeddamageoptions-other";
export const OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER = "typeobserveddamageoptions-other";
export const OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER = "productdiscoloredoptions-other";
export const OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER = "specificallydescribesoptions-other";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER = "matterforeignmaterialpiecesoptions-other";
export const OPTION_PRODUCTTHAWEDOPTIONS_OTHER = "productthawedoptions-other";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER = "damageissueobservedoptions-other";
export const OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER = "damagespecificinfooptions-other";
export const OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER = "appropriatedescriptionoptions-other";
export const OPTION_LABELINGISSUEOPTIONS_OTHER = "labelingissueoptions-other";
export const OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER = "whatincorrectlydisplayedoptions-other";
export const OPTION_MOISTUREOBSERVEDOPTIONS_OTHER = "moistureobservedoptions-other";
export const OPTION_COMPONENTLEAKINGOPTIONS_OTHER = "componentleakingoptions-other";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER = "whattypedamageissueoptions-other";
export const OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER = "situationdescribesissueoptions-other";
export const OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER = "followingscenariosoptions-other";
export const OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER = "situationflowissueoptions-other";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER = "situationsapplyeventoptions-other";
export const OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER = "simultaneousflowoptions-other";
export const OPTION_WHATCLAMPFAILEDOPTIONS_OTHER = "whatclampfailedoptions-other";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER = "clampissueexperiencedoptions-other";
export const OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER = "clampdescribesissueoptions-other";
export const OPTION_PRODUCTDAMAGEDOPTIONS_OTHER = "productdamagedoptions-other";
export const OPTION_COMPONENTHADISSUEOPTIONS_OTHER = "componenthadissueoptions-other";

export const OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE = "followingoccuroptions-none-of-the-above";


export const OPTION_PREVIOUSLYREPORTEDOPTIONS_NO = "previouslyreportedoptions-no";
export const OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN = "previouslyreportedoptions-unknown";
export const OPTION_PREVIOUSLYREPORTEDOPTIONS_YES = "previouslyreportedoptions-yes";

export const OPTION_ADDANOTHERFACILITYOPTIONS_NO = "addanotherfacilityoptions-no";
export const OPTION_ADDANOTHERFACILITYOPTIONS_YES = "addanotherfacilityoptions-yes";

export const OPTION_PATIENINVOLVEMENTOPTIONS_NO = "patieninvolvementoptions-no";
export const OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN = "patieninvolvementoptions-unknown";
export const OPTION_PATIENINVOLVEMENTOPTIONS_YES = "patieninvolvementoptions-yes";

export const OPTION_OTHERFACILITYREPORTOPTIONS_NO = "otherfacilityreportoptions-no";
export const OPTION_OTHERFACILITYREPORTOPTIONS_YES = "otherfacilityreportoptions-yes";

export const OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN = "availabilityoptionsdistributor-asked-nknown";
export const OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO = "availabilityoptionsdistributor-no";
export const OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN = "availabilityoptionsdistributor-unknown";
export const OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES = "availabilityoptionsdistributor-yes";

export const OPTION_AVAILABILITYOPTIONS_NO = "availabilityoptions-no";
export const OPTION_AVAILABILITYOPTIONS_YES = "availabilityoptions-yes";

export const OPTION_MEDIAAVAILABILITYOPTIONS_NO = "mediaavailabilityoptions-no";
export const OPTION_MEDIAAVAILABILITYOPTIONS_YES = "mediaavailabilityoptions-yes";

export const OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO = "mediaavailabilitydistributoroptions-no";
export const OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN = "mediaavailabilitydistributoroptions-unknown";
export const OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES = "mediaavailabilitydistributoroptions-yes";

export const OPTION_UNUSEDAVAILABILITYOPTIONS_NO = "unusedavailabilityoptions-no";
export const OPTION_UNUSEDAVAILABILITYOPTIONS_YES = "unusedavailabilityoptions-yes";

export const OPTION_SELFNEGATIVEIMPACTOPTIONS_NO = "selfnegativeimpactoptions-no";
export const OPTION_SELFNEGATIVEIMPACTOPTIONS_YES = "selfnegativeimpactoptions-yes";

export const OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO = "patientnegativeimpactoptions-no";
export const OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES = "patientnegativeimpactoptions-yes";

export const OPTION_COUNTERACTIONOPTIONS_NO = "counteractionoptions-no";
export const OPTION_COUNTERACTIONOPTIONS_YES = "counteractionoptions-yes";

export const OPTION_DRUGUSEDOPTIONS_NO = "drugusedoptions-no";
export const OPTION_DRUGUSEDOPTIONS_YES = "drugusedoptions-yes";

export const OPTION_SHARECONTACTOPTIONS_NO = "sharecontactoptions-no";
export const OPTION_SHARECONTACTOPTIONS_YES = "sharecontactoptions-yes";

export const OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO = "explicitinvestigationrequestoptions-no";
export const OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES = "explicitinvestigationrequestoptions-yes";

export const OPTION_DIRECTORDEROPTIONS_NO = "directorderoptions-no";
export const OPTION_DIRECTORDEROPTIONS_YES = "directorderoptions-yes";

export const OPTION_EXCESSIVEFORCEOPTIONS_NO = "excessiveforceoptions-no";
export const OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN = "excessiveforceoptions-unknown";
export const OPTION_EXCESSIVEFORCEOPTIONS_YES = "excessiveforceoptions-yes";

export const OPTION_TWISTCLAMPOPTIONS_NO = "twistclampoptions-no";
export const OPTION_TWISTCLAMPOPTIONS_UNKNOWN = "twistclampoptions-unknown";
export const OPTION_TWISTCLAMPOPTIONS_YES = "twistclampoptions-yes";

export const OPTION_DIFFICULTIESMINICAPOPTIONS_NO = "difficultiesminicapoptions-no";
export const OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN = "difficultiesminicapoptions-unknown";
export const OPTION_ENVIRONMENTOPTIONS_NO = "environmentoptions-no";
export const OPTION_ENVIRONMENTOPTIONS_UNKNOWN = "environmentoptions-unknown";
export const OPTION_ENVIRONMENTOPTIONS_YES = "environmentoptions-yes";

export const OPTION_SPONGEVISIBLEOPTIONS_NO = "spongevisibleoptions-no";
export const OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN = "spongevisibleoptions-unknown";
export const OPTION_SPONGEVISIBLEOPTIONS_YES = "spongevisibleoptions-yes";

export const OPTION_MATERIALEMBEDDEDOPTIONS_NO = "materialembeddedoptions-no";
export const OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN = "materialembeddedoptions-unknown";
export const OPTION_MATERIALEMBEDDEDOPTIONS_YES = "materialembeddedoptions-yes";

export const OPTION_PIECESMATERIALOPTIONS_NO = "piecesmaterialoptions-no";
export const OPTION_PIECESMATERIALOPTIONS_UNKNOWN = "piecesmaterialoptions-unknown";
export const OPTION_PIECESMATERIALOPTIONS_YES = "piecesmaterialoptions-yes";

export const OPTION_DISPOSABLECONNECTIONOPTIONS_NO = "disposableconnectionoptions-no";
export const OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN = "disposableconnectionoptions-unknown";
export const OPTION_DISPOSABLECONNECTIONOPTIONS_YES = "disposableconnectionoptions-yes";

export const OPTION_INITIALCONNECTIONOPTIONS_NO = "initialconnectionoptions-no";
export const OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN = "initialconnectionoptions-unknown";
export const OPTION_INITIALCONNECTIONOPTIONS_YES = "initialconnectionoptions-yes";

export const OPTION_SPIKELUERCONNECTORSOPTIONS_NO = "spikeluerconnectorsoptions-no";
export const OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN = "spikeluerconnectorsoptions-unknown";
export const OPTION_SPIKELUERCONNECTORSOPTIONS_YES = "spikeluerconnectorsoptions-yes";

export const OPTION_PETSORANIMALSOPTIONS_NO = "petsoranimalsoptions-no";
export const OPTION_PETSORANIMALSOPTIONS_UNKNOWN = "petsoranimalsoptions-unknown";
export const OPTION_PETSORANIMALSOPTIONS_YES = "petsoranimalsoptions-yes";

export const OPTION_MINICAPTWISTEDOPTIONS_NO = "minicaptwistedoptions-no";
export const OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN = "minicaptwistedoptions-unknown";
export const OPTION_MINICAPTWISTEDOPTIONS_YES = "minicaptwistedoptions-yes";

export const OPTION_TRANSFERSETOPTIONS_NO = "transfersetoptions-no";
export const OPTION_TRANSFERSETOPTIONS_UNKNOWN = "transfersetoptions-unknown";
export const OPTION_TRANSFERSETOPTIONS_YES = "transfersetoptions-yes";

export const OPTION_RESIDUETHREADSOPTIONS_NO = "residuethreadsoptions-no";
export const OPTION_RESIDUETHREADSOPTIONS_UNKNOWN = "residuethreadsoptions-unknown";

export const OPTION_DAMAGECAUSELEAKOPTIONS_NO = "damagecauseleakoptions-no";
export const OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN = "damagecauseleakoptions-unknown";
export const OPTION_DAMAGECAUSELEAKOPTIONS_YES = "damagecauseleakoptions-yes";

export const OPTION_SHIPPINGCARTONOPENOPTIONS_NO = "shippingcartonopenoptions-no";
export const OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN = "shippingcartonopenoptions-unknown";
export const OPTION_SHIPPINGCARTONOPENOPTIONS_YES = "shippingcartonopenoptions-yes";

export const OPTION_ADAPTERDEVICEOPTIONS_NO = "adapterdeviceoptions-no";
export const OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN = "adapterdeviceoptions-unknown";
export const OPTION_ADAPTERDEVICEOPTIONS_YES = "adapterdeviceoptions-yes";

export const OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO = "squeezingsolutionoptionss-no";
export const OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN = "squeezingsolutionoptionss-unknown";
export const OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES = "squeezingsolutionoptionss-yes";

export const OPTION_FORTHMOTIONOPTIONS_NO = "forthmotionoptions-no";
export const OPTION_FORTHMOTIONOPTIONS_UNKNOWN = "forthmotionoptions-unknown";
export const OPTION_FORTHMOTIONOPTIONS_YES = "forthmotionoptions-yes";

export const OPTION_ALARMNOFLOWOPTIONS_NO = "alarmnoflowoptions-no";
export const OPTION_ALARMNOFLOWOPTIONS_UNKNOWN = "alarmnoflowoptions-unknown";
export const OPTION_ALARMNOFLOWOPTIONS_YES = "alarmnoflowoptions-yes";

export const OPTION_DISCOLORATIONMARKINGSOPTIONS_NO = "discolorationmarkingsoptions-no";
export const OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN = "discolorationmarkingsoptions-unknown";
export const OPTION_DISCOLORATIONMARKINGSOPTIONS_YES = "discolorationmarkingsoptions-yes";

export const OPTION_BROKENACTIVATEDOPTIONS_NO = "brokenactivatedoptions-no";
export const OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN = "brokenactivatedoptions-unknown";
export const OPTION_BROKENACTIVATEDOPTIONS_YES = "brokenactivatedoptions-yes";

export const OPTION_vaporizerSightGlassOptions_NO = "vaporizersightglassoptions-no";
export const OPTION_vaporizerSightGlassOptions_UNKNOWN = "vaporizersightglassoptions-unknown";
export const OPTION_vaporizerSightGlassOptions_YES = "vaporizersightglassoptions-yes";

export const OPTION_PRODUCTHEATOPTIONS_NO = "productheatoptions-no";
export const OPTION_PRODUCTHEATOPTIONS_UNKNOWN = "productheatoptions-unknown";
export const OPTION_PRODUCTHEATOPTIONS_YES = "productheatoptions-yes";

export const OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO = "damageprioractivationoptions-no";
export const OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN = "damageprioractivationoptions-unknown";
export const OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES = "damageprioractivationoptions-yes";

export const OPTION_LEAKOBSERVEDOPTIONS_NO = "leakobservedoptions-no";
export const OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN = "leakobservedoptions-unknown";
export const OPTION_LEAKOBSERVEDOPTIONS_YES = "leakobservedoptions-yes";

export const OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO = "embeddedintheproductoptions-no";
export const OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN = "embeddedintheproductoptions-unknown";
export const OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES = "embeddedintheproductoptions-yes";

export const OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO = "wassolutionaddedproductoptions-no";
export const OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN = "wassolutionaddedproductoptions-unknown";
export const OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES = "wassolutionaddedproductoptions-yes";

export const OPTION_CLOUDINESSGOAWAYOPTIONS_NO = "cloudinessgoawayoptions-no";
export const OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN = "cloudinessgoawayoptions-unknown";
export const OPTION_CLOUDINESSGOAWAYOPTIONS_YES = "cloudinessgoawayoptions-yes";

export const OPTION_AGITATEUNITOPTIONS_NO = "agitateunitoptions-no";
export const OPTION_AGITATEUNITOPTIONS_UNKNOWN = "agitateunitoptions-unknown";
export const OPTION_AGITATEUNITOPTIONS_YES = "agitateunitoptions-yes";

export const OPTION_PRECIPITATEDISSOLVEOPTIONS_NO = "precipitatedissolveoptions-no";
export const OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN = "precipitatedissolveoptions-unknown";
export const OPTION_PRECIPITATEDISSOLVEOPTIONS_YES = "precipitatedissolveoptions-yes";

export const OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO = "temperaturelogsfreezeroptions-no";
export const OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN = "temperaturelogsfreezeroptions-unknown";
export const OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES = "temperaturelogsfreezeroptions-yes";

export const OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO = "storageunitcalibratedoptionss-no";
export const OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN = "storageunitcalibratedoptionss-unknown";
export const OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES = "storageunitcalibratedoptionss-yes";

export const OPTION_RECENTPRESCRIPTIONOPTIONS_NO = "recentprescriptionoptions-no";
export const OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN = "recentprescriptionoptions-unknown";
export const OPTION_RECENTPRESCRIPTIONOPTIONS_YES = "recentprescriptionoptions-yes";

export const OPTION_EXPIREDPRODUCTOPTIONS_NO = "expiredproductoptions-no";
export const OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN = "expiredproductoptions-unknown";
export const OPTION_EXPIREDPRODUCTOPTIONS_YES = "expiredproductoptions-yes";

export const OPTION_ABNORMALITIESDAMAGEOPTIONS_NO = "abnormalitiesdamageoptions-no";
export const OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN = "abnormalitiesdamageoptions-unknown";
export const OPTION_ABNORMALITIESDAMAGEOPTIONS_YES = "abnormalitiesdamageoptions-yes";

export const OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO = "overpouchpouchscanningoptions-no";
export const OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN = "overpouchpouchscanningoptions-unknown";
export const OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES = "overpouchpouchscanningoptions-yes";

export const OPTION_LABELSSAMEINFORMATIONOPTIONS_NO = "labelssameinformationoptions-no";
export const OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN = "labelssameinformationoptions-unknown";
export const OPTION_LABELSSAMEINFORMATIONOPTIONS_YES = "labelssameinformationoptions-yes";

export const OPTION_BARCODESCANNEROPTIONS_NO = "barcodescanneroptions-no";
export const OPTION_BARCODESCANNEROPTIONS_UNKNOWN = "barcodescanneroptions-unknown";
export const OPTION_BARCODESCANNEROPTIONS_YES = "barcodescanneroptions-yes";

export const OPTION_FRANGIBLEOBSERVEDOPTIONS_NO = "frangibleobservedoptions-no";
export const OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN = "frangibleobservedoptions-unknown";
export const OPTION_FRANGIBLEOBSERVEDOPTIONS_YES = "frangibleobservedoptions-yes";

export const OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO = "frangibledamagedefectoptions-no";
export const OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN = "frangibledamagedefectoptions-unknown";
export const OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES = "frangibledamagedefectoptions-yes";

export const OPTION_FRANGIBLEBROKENOPTIONS_NO = "frangiblebrokenoptions-no";
export const OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN = "frangiblebrokenoptions-unknown";
export const OPTION_FRANGIBLEBROKENOPTIONS_YES = "frangiblebrokenoptions-yes";


export const OPTION_MOISTURECLEAROPTIONS_UNKNOWN = "moistureclearoptions-unknown";
export const OPTION_MOISTURECLEAROPTIONS_YES = "moistureclearoptions-yes";

export const OPTION_DIFFICULTYSPIKINGOPTIONS_NO = "difficultyspikingoptions-no";
export const OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN = "difficultyspikingoptions-unknown";
export const OPTION_DIFFICULTYSPIKINGOPTIONS_YES = "difficultyspikingoptions-yes";

export const OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO = "wasfrangibledamageoptions-no";
export const OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN = "wasfrangibledamageoptions-unknown";
export const OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES = "wasfrangibledamageoptions-yes";

export const OPTION_PRESSURECUFFOPTIONS_NO = "pressurecuffoptions-no";
export const OPTION_PRESSURECUFFOPTIONS_UNKNOWN = "pressurecuffoptions-unknown";
export const OPTION_PRESSURECUFFOPTIONS_YES = "pressurecuffoptions-yes";


export const OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN = "liquidspilledoptions-unknown";


export const OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO = "bottleintovaporizeroptions-no";
export const OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN = "bottleintovaporizeroptions-unknown";
export const OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES = "bottleintovaporizeroptions-yes";

export const OPTION_REMOVEDFROMPACKAGEOPTIONS_NO = "removedfrompackageoptions-no";
export const OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN = "removedfrompackageoptions-unknown";
export const OPTION_REMOVEDFROMPACKAGEOPTIONS_YES = "removedfrompackageoptions-yes";

export const OPTION_ADDINGMEDICATIONOPTIONS_NO = "addingmedicationoptions-no";
export const OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN = "addingmedicationoptions-unknown";
export const OPTION_ADDINGMEDICATIONOPTIONS_YES = "addingmedicationoptions-yes";

export const OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO = "patientconnectedproductoptions-no";
export const OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN = "patientconnectedproductoptions-unknown";
export const OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES = "patientconnectedproductoptions-yes";

export const OPTION_WASPRODUCTREPLACEDOPTIONS_NO = "wasproductreplacedoptions-no";
export const OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN = "wasproductreplacedoptions-unknown";
export const OPTION_WASPRODUCTREPLACEDOPTIONS_YES = "wasproductreplacedoptions-yes";

export const OPTION_WASPOWERINJECTOROPTIONS_NO = "waspowerinjectoroptions-no";
export const OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN = "waspowerinjectoroptions-unknown";
export const OPTION_WASPOWERINJECTOROPTIONS_YES = "waspowerinjectoroptions-yes";

export const OPTION_INJECTIONSITEOPENINGOPTIONS_NO = "injectionsiteopeningoptions-no";
export const OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN = "injectionsiteopeningoptions-unknown";
export const OPTION_INJECTIONSITEOPENINGOPTIONS_YES = "injectionsiteopeningoptions-yes";
export const OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER = "injectionsiteopeningoptions-other";

export const OPTION_VISIBLEIRREGULARITIESOPTIONS_NO = "visibleirregularitiesoptions-no";
export const OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN = "visibleirregularitiesoptions-unknown";

export const OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO = "eventuallyestablishedoptions-no";
export const OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN = "eventuallyestablishedoptions-unknown";
export const OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES = "eventuallyestablishedoptions-yes";

export const OPTION_TOOLUSEDASSISTOPTIONS_NO = "toolusedassistoptions-no";
export const OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN = "toolusedassistoptions-unknown";

export const OPTION_SECUREPRIORUSEOPTIONS_NO = "secureprioruseoptions-no";
export const OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN = "secureprioruseoptions-unknown";
export const OPTION_SECUREPRIORUSEOPTIONS_YES = "secureprioruseoptions-yes";

export const OPTION_PRIORDISCONNECTINGOPTIONS_NO = "priordisconnectingoptions-no";
export const OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN = "priordisconnectingoptions-unknown";
export const OPTION_PRIORDISCONNECTINGOPTIONS_YES = "priordisconnectingoptions-yes";

export const OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO = "flowpreviouslyseenoptions-no";
export const OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN = "flowpreviouslyseenoptions-unknown";
export const OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES = "flowpreviouslyseenoptions-yes";

export const OPTION_YSITECONNECTEDOPTIONS_UNKNOWN = "ysiteconnectedoptions-unknown";

export const OPTION_COMPONENTSETREPLACEDOPTIONS_NO = "componentsetreplacedoptions-no";
export const OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN = "componentsetreplacedoptions-unknown";
export const OPTION_COMPONENTSETREPLACEDOPTIONS_YES = "componentsetreplacedoptions-yes";

export const OPTION_WITHPUMPOPTIONS_NO = "withpumpoptions-no";
export const OPTION_WITHPUMPOPTIONS_UNKNOWN = "withpumpoptions-unknown";

export const OPTION_CLAMPFAILOPTIONS_NO = "clampfailoptions-no";
export const OPTION_CLAMPFAILOPTIONS_UNKNOWN = "clampfailoptions-unknown";
export const OPTION_CLAMPFAILOPTIONS_YES = "clampfailoptions-yes";

export const OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO = "issuesobservedclampoptions-no";
export const OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN = "issuesobservedclampoptions-unknown";

export const OPTION_WASMATERIALEMBEDDEDOPTIONS_NO = "wasmaterialembeddedoptions-no";
export const OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN = "wasmaterialembeddedoptions-unknown";
export const OPTION_WASMATERIALEMBEDDEDOPTIONS_YES = "wasmaterialembeddedoptions-yes";

export const OPTION_APPEARPRODUCTMATERIALOPTIONS_NO = "appearproductmaterialoptions-no";
export const OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN = "appearproductmaterialoptions-unknown";
export const OPTION_APPEARPRODUCTMATERIALOPTIONS_YES = "appearproductmaterialoptions-yes";

export const OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO = "shippingcartondamagedoptions-no";
export const OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN = "shippingcartondamagedoptions-unknown";
export const OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES = "shippingcartondamagedoptions-yes";

export const OPTION_GELPACKSOPTIONS_NO = "gelpacksoptions-no";
export const OPTION_GELPACKSOPTIONS_YES = "gelpacksoptions-yes";

export const OPTION_EXPIREDPRODUCTUSEOPTIONS_NO = "expiredproductuseoptions-no";
export const OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN = "expiredproductuseoptions-unknown";
export const OPTION_EXPIREDPRODUCTUSEOPTIONS_YES = "expiredproductuseoptions-yes";

export const OPTION_ALARMOPTIONS_NO = "alarmoptions-no";
export const OPTION_ALARMOPTIONS_UNKNOWN = "alarmoptions-unknown";


export const OPTION_CLEANINGSOLUTIONSOPTIONS_NO = "cleaningsolutionsoptions-no";
export const OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN = "cleaningsolutionsoptions-unknown";
export const OPTION_CLEANINGSOLUTIONSOPTIONS_YES = "cleaningsolutionsoptions-yes";

export const OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO = "difficultintwistclampoptions-no";
export const OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN = "difficultintwistclampoptions-unknown";

export const OPTION_TRANSFERREPLACEDOPTIONS_NO = "transferreplacedoptions-no";
export const OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN = "transferreplacedoptions-unknown";
export const OPTION_TRANSFERREPLACEDOPTIONS_YES = "transferreplacedoptions-yes";

export const OPTION_FULLYTIGHTENEDOPTIONS_NO = "fullytightenedoptions-no";
export const OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN = "fullytightenedoptions-unknown";
export const OPTION_FULLYTIGHTENEDOPTIONS_YES = "fullytightenedoptions-yes";

export const OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO = "anycomponentdamagedoptionss-no";
export const OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN = "anycomponentdamagedoptionss-unknown";

export const OPTION_ISSUERESULTLEAKOPTIONS_NO = "issueresultleakoptions-no";
export const OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN = "issueresultleakoptions-unknown";
export const OPTION_ISSUERESULTLEAKOPTIONS_YES = "issueresultleakoptions-yes";
export const OPTION_ISSUERESULTLEAKOPTIONS_OTHER = "issueresultleakoptions-other";

export const OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO = "samplesavailableforevaluationoptions-no";
export const OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES = "samplesavailableforevaluationoptions-yes";

export const OPTION_EXPLICITLYREQUESTOPTIONS_NO = "explicitlyrequestoptions-no";
export const OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN = "explicitlyrequestoptions-unknown";
export const OPTION_EXPLICITLYREQUESTOPTIONS_YES = "explicitlyrequestoptions-yes";

export const OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO = "werepatientusingproductoptions-no";
export const OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN = "werepatientusingproductoptions-unknown";
export const OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES = "werepatientusingproductoptions-yes";
export const OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN = "patieninvolvementoptions-asked-unknown";
export const OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN = "mediaavailabilitydistributoroptions-asked-unknown";

export const OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN = "chamberdiscoloredoptions-unknown";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN = "matterforeignmaterialpiecesoptions-unknown";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO = "damageissueobservedoptions-no";
export const OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN = "damageissueobservedoptions-unknown";
export const OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN = "scenariosleakoptions-unknown";
export const OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE = "scenariosleakoptions-none-of-the-above";
export const OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR = "moistureclearoptions-No-describe-the-color";
export const OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN = "embeddedplasticoptions-unknown";
export const OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN = "whattypedamageissueoptions-unknown";
export const OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL = "yes-specify-the-tool-used";
export const OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION = "situationsapplyeventoptions-separation";
export const OPTION_HANGERUSEDOPTIONS_UNKNOWN = "hangerusedoptions-unknown";
export const OPTION_HANGERUSEDOPTIONS_NONE = "hangerusedoptions-hangerusedoptions-none";
export const OPTION_BAGLOWEROPTIONS_UNKNOWN = "bagloweroptions-unknown";
export const OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER = "issuesobservedclampoptions-yes-other";
export const OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN = "clampissueexperiencedoptions-unknown";
export const OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO = "matterforeignmaterialpiecesoptions-no";

export const OPTION_WEIGHTUNITOPTIONS_KILOGRAM = "weightunitoptions-kilogram";
export const OPTION_WEIGHTUNITOPTIONS_POUND = "weightunitoptions-pound";
export const OPTION_INFUSATESOLUTIONOPTIONS_NO = "infusatesolutionoptions-no";
export const OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN = "infusatesolutionoptions-unknown";

//Error Message translations
export const PLEASE_ENTER_THE_VALUE = "please-enter-the-value";
export const PLEASE_SELECT_THE_VALUE = "please-select-the-value";
export const PLEASE_SELECT_THE_DATE = "please-select-the-date";
export const PLEASE_CHOOSE_THE_VALUE = "please-choose-the-date";
export const OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN = "mediaavailabilityoptions-unknown";

//Country Option
export const OPTION_COUNTRYOPTIONS_GREAT_BRITAIN =  "countryoptions-great-britain";
export const OPTION_COUNTRYOPTIONS_KOSOVO =  "countryoptions-kosovo";
export const OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND =  "countryoptions-northern-ireland";
export const OPTION_COUNTRYOPTIONS_AFGHANISTAN =  "countryoptions-afghanistan";
export const OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS =  "countryoptions-åland-islands";
export const OPTION_COUNTRYOPTIONS_ALBANIA =  "countryoptions-albania";
export const OPTION_COUNTRYOPTIONS_ALGERIA =  "countryoptions-algeria";
export const OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA =  "countryoptions-american-samoa";
export const OPTION_COUNTRYOPTIONS_ANDORRA =  "countryoptions-andorra";
export const OPTION_COUNTRYOPTIONS_ANGOLA =  "countryoptions-angola";
export const OPTION_COUNTRYOPTIONS_ANGUILLA =  "countryoptions-anguilla";
export const OPTION_COUNTRYOPTIONS_ANTARCTICA =  "countryoptions-antarctica";
export const OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA =  "countryoptions-antigua-and-barbuda";
export const OPTION_COUNTRYOPTIONS_ARGENTINA =  "countryoptions-argentina";
export const OPTION_COUNTRYOPTIONS_ARMENIA =  "countryoptions-armenia";
export const OPTION_COUNTRYOPTIONS_ARUBA =  "countryoptions-aruba";
export const OPTION_COUNTRYOPTIONS_AUSTRALIA =  "countryoptions-australia";
export const OPTION_COUNTRYOPTIONS_AUSTRIA =  "countryoptions-austria";
export const OPTION_COUNTRYOPTIONS_AZERBAIJAN =  "countryoptions-azerbaijan";
export const OPTION_COUNTRYOPTIONS_BAHAMAS =  "countryoptions-bahamas";
export const OPTION_COUNTRYOPTIONS_BAHRAIN =  "countryoptions-bahrain";
export const OPTION_COUNTRYOPTIONS_BANGLADESH =  "countryoptions-bangladesh";
export const OPTION_COUNTRYOPTIONS_BARBADOS =  "countryoptions-barbados";
export const OPTION_COUNTRYOPTIONS_BELARUS =  "countryoptions-belarus";
export const OPTION_COUNTRYOPTIONS_BELGIUM =  "countryoptions-belgium";
export const OPTION_COUNTRYOPTIONS_BELIZE =  "countryoptions-belize";
export const OPTION_COUNTRYOPTIONS_BENIN =  "countryoptions-benin";
export const OPTION_COUNTRYOPTIONS_BERMUDA =  "countryoptions-bermuda";
export const OPTION_COUNTRYOPTIONS_BHUTAN =  "countryoptions-bhutan";
export const OPTION_COUNTRYOPTIONS_BOLIVIA =  "countryoptions-bolivia";
export const OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA =  "countryoptions-bosnia-and-herzegovina";
export const OPTION_COUNTRYOPTIONS_BOTSWANA =  "countryoptions-botswana";
export const OPTION_COUNTRYOPTIONS_BOUVET_ISLAND =  "countryoptions-bouvet-island";
export const OPTION_COUNTRYOPTIONS_BRAZIL =  "countryoptions-brazil";
export const OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY =  "countryoptions-british-indian-ocean-territory";
export const OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM =  "countryoptions-brunei-darussalam";
export const OPTION_COUNTRYOPTIONS_BULGARIA =  "countryoptions-bulgaria";
export const OPTION_COUNTRYOPTIONS_BURKINA_FASO =  "countryoptions-burkina-faso";
export const OPTION_COUNTRYOPTIONS_BURUNDI =  "countryoptions-burundi";
export const OPTION_COUNTRYOPTIONS_CAMBODIA =  "countryoptions-cambodia";
export const OPTION_COUNTRYOPTIONS_CAMEROON =  "countryoptions-cameroon";
export const OPTION_COUNTRYOPTIONS_CANADA =  "countryoptions-canada";
export const OPTION_COUNTRYOPTIONS_CAPE_VERDE =  "countryoptions-cape-verde";
export const OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS =  "countryoptions-cayman-islands";
export const OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC =  "countryoptions-central-african-republic";
export const OPTION_COUNTRYOPTIONS_CHAD =  "countryoptions-chad";
export const OPTION_COUNTRYOPTIONS_CHILE =  "countryoptions-chile";
export const OPTION_COUNTRYOPTIONS_CHINA =  "countryoptions-china";
export const OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND =  "countryoptions-christmas-island";
export const OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS =  "countryoptions-cocos-keeling-islands";
export const OPTION_COUNTRYOPTIONS_COLOMBIA =  "countryoptions-colombia";
export const OPTION_COUNTRYOPTIONS_COMOROS =  "countryoptions-comoros";
export const OPTION_COUNTRYOPTIONS_CONGO =  "countryoptions-congo";
export const OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE =  "countryoptions-congo-the-democratic-republic-of-the";
export const OPTION_COUNTRYOPTIONS_COOK_ISLANDS =  "countryoptions-cook-islands";
export const OPTION_COUNTRYOPTIONS_COSTA_RICA =  "countryoptions-costa-rica";
export const OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST =  "countryoptions-côte-divoire-ivory-coast";
export const OPTION_COUNTRYOPTIONS_CROATIA =  "countryoptions-croatia";
export const OPTION_COUNTRYOPTIONS_CUBA =  "countryoptions-cuba";
export const OPTION_COUNTRYOPTIONS_CYPRUS =  "countryoptions-cyprus";
export const OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC =  "countryoptions-czech-republic";
export const OPTION_COUNTRYOPTIONS_DENMARK =  "countryoptions-denmark";
export const OPTION_COUNTRYOPTIONS_DJIBOUTI =  "countryoptions-djibouti";
export const OPTION_COUNTRYOPTIONS_DOMINICA =  "countryoptions-dominica";
export const OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC =  "countryoptions-dominican-republic";
export const OPTION_COUNTRYOPTIONS_ECUADOR =  "countryoptions-ecuador";
export const OPTION_COUNTRYOPTIONS_EGYPT =  "countryoptions-egypt";
export const OPTION_COUNTRYOPTIONS_EL_SALVADOR =  "countryoptions-el-salvador";
export const OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA =  "countryoptions-equatorial-guinea";
export const OPTION_COUNTRYOPTIONS_ERITREA =  "countryoptions-eritrea";
export const OPTION_COUNTRYOPTIONS_ESTONIA =  "countryoptions-estonia";
export const OPTION_COUNTRYOPTIONS_ETHIOPIA =  "countryoptions-ethiopia";
export const OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS =  "countryoptions-falkland-islands-malvinas";
export const OPTION_COUNTRYOPTIONS_FAROE_ISLANDS =  "countryoptions-faroe-islands";
export const OPTION_COUNTRYOPTIONS_FIJI =  "countryoptions-fiji";
export const OPTION_COUNTRYOPTIONS_FINLAND =  "countryoptions-finland";
export const OPTION_COUNTRYOPTIONS_FRANCE =  "countryoptions-france";
export const OPTION_COUNTRYOPTIONS_FRENCH_GUIANA =  "countryoptions-french-guiana";
export const OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA =  "countryoptions-french-polynesia";
export const OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES =  "countryoptions-french-southern-territories";
export const OPTION_COUNTRYOPTIONS_GABON =  "countryoptions-gabon";
export const OPTION_COUNTRYOPTIONS_GAMBIA =  "countryoptions-gambia";
export const OPTION_COUNTRYOPTIONS_GEORGIA =  "countryoptions-georgia";
export const OPTION_COUNTRYOPTIONS_GERMANY =  "countryoptions-germany";
export const OPTION_COUNTRYOPTIONS_GHANA =  "countryoptions-ghana";
export const OPTION_COUNTRYOPTIONS_GIBRALTAR =  "countryoptions-gibraltar";
export const OPTION_COUNTRYOPTIONS_GREECE =  "countryoptions-greece";
export const OPTION_COUNTRYOPTIONS_GREENLAND =  "countryoptions-greenland";
export const OPTION_COUNTRYOPTIONS_GRENADA =  "countryoptions-grenada";
export const OPTION_COUNTRYOPTIONS_GUADELOUPE =  "countryoptions-guadeloupe";
export const OPTION_COUNTRYOPTIONS_GUAM =  "countryoptions-guam";
export const OPTION_COUNTRYOPTIONS_GUATEMALA =  "countryoptions-guatemala";
export const OPTION_COUNTRYOPTIONS_GUERNSEY =  "countryoptions-guernsey";
export const OPTION_COUNTRYOPTIONS_GUINEA =  "countryoptions-guinea";
export const OPTION_COUNTRYOPTIONS_GUINEA_BISSAU =  "countryoptions-guinea-bissau";
export const OPTION_COUNTRYOPTIONS_GUYANA =  "countryoptions-guyana";
export const OPTION_COUNTRYOPTIONS_HAITI =  "countryoptions-haiti";
export const OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS =  "countryoptions-heard-island-and-mcdonald-islands";
export const OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE =  "countryoptions-holy-see-vatican-city-state";
export const OPTION_COUNTRYOPTIONS_HONDURAS =  "countryoptions-honduras";
export const OPTION_COUNTRYOPTIONS_HONG_KONG =  "countryoptions-hong-kong";
export const OPTION_COUNTRYOPTIONS_HUNGARY =  "countryoptions-hungary";
export const OPTION_COUNTRYOPTIONS_ICELAND =  "countryoptions-iceland";
export const OPTION_COUNTRYOPTIONS_INDIA =  "countryoptions-india";
export const OPTION_COUNTRYOPTIONS_INDONESIA =  "countryoptions-indonesia";
export const OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF =  "countryoptions-iran-islamic-republic-of";
export const OPTION_COUNTRYOPTIONS_IRAQ =  "countryoptions-iraq";
export const OPTION_COUNTRYOPTIONS_IRELAND =  "countryoptions-ireland";
export const OPTION_COUNTRYOPTIONS_ISLE_OF_MAN =  "countryoptions-isle-of-man";
export const OPTION_COUNTRYOPTIONS_ISRAEL =  "countryoptions-israel";
export const OPTION_COUNTRYOPTIONS_ITALY =  "countryoptions-italy";
export const OPTION_COUNTRYOPTIONS_JAMAICA =  "countryoptions-jamaica";
export const OPTION_COUNTRYOPTIONS_JAPAN =  "countryoptions-japan";
export const OPTION_COUNTRYOPTIONS_JERSEY =  "countryoptions-jersey";
export const OPTION_COUNTRYOPTIONS_JORDAN =  "countryoptions-jordan";
export const OPTION_COUNTRYOPTIONS_KAZAKHSTAN =  "countryoptions-kazakhstan";
export const OPTION_COUNTRYOPTIONS_KENYA =  "countryoptions-kenya";
export const OPTION_COUNTRYOPTIONS_KIRIBATI =  "countryoptions-kiribati";
export const OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF =  "countryoptions-korea-democratic-peoples-republic-of";
export const OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF =  "countryoptions-korea-republic-of";
export const OPTION_COUNTRYOPTIONS_KUWAIT =  "countryoptions-kuwait";
export const OPTION_COUNTRYOPTIONS_KYRGYZSTAN =  "countryoptions-kyrgyzstan";
export const OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC =  "countryoptions-lao-peoples-democratic-republic";
export const OPTION_COUNTRYOPTIONS_LATVIA =  "countryoptions-latvia";
export const OPTION_COUNTRYOPTIONS_LEBANON =  "countryoptions-lebanon";
export const OPTION_COUNTRYOPTIONS_LESOTHO =  "countryoptions-lesotho";
export const OPTION_COUNTRYOPTIONS_LIBERIA =  "countryoptions-liberia";
export const OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA =  "countryoptions-libyan-arab-jamahiriya";
export const OPTION_COUNTRYOPTIONS_LIECHTENSTEIN =  "countryoptions-liechtenstein";
export const OPTION_COUNTRYOPTIONS_LITHUANIA =  "countryoptions-lithuania";
export const OPTION_COUNTRYOPTIONS_LUXEMBOURG =  "countryoptions-luxembourg";
export const OPTION_COUNTRYOPTIONS_MACAO =  "countryoptions-macao";
export const OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF =  "countryoptions-macedonia-the-former-yugoslav-republic-of";
export const OPTION_COUNTRYOPTIONS_MADAGASCAR =  "countryoptions-madagascar";
export const OPTION_COUNTRYOPTIONS_MALAWI =  "countryoptions-malawi";
export const OPTION_COUNTRYOPTIONS_MALAYSIA =  "countryoptions-malaysia";
export const OPTION_COUNTRYOPTIONS_MALDIVES =  "countryoptions-maldives";
export const OPTION_COUNTRYOPTIONS_MALI =  "countryoptions-mali";
export const OPTION_COUNTRYOPTIONS_MALTA =  "countryoptions-malta";
export const OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS =  "countryoptions-marshall-islands";
export const OPTION_COUNTRYOPTIONS_MARTINIQUE =  "countryoptions-martinique";
export const OPTION_COUNTRYOPTIONS_MAURITANIA =  "countryoptions-mauritania";
export const OPTION_COUNTRYOPTIONS_MAURITIUS =  "countryoptions-mauritius";
export const OPTION_COUNTRYOPTIONS_MAYOTTE =  "countryoptions-mayotte";
export const OPTION_COUNTRYOPTIONS_MEXICO =  "countryoptions-mexico";
export const OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF =  "countryoptions-micronesia-federated-states-of";
export const OPTION_COUNTRYOPTIONS_MOLDOVA =  "countryoptions-moldova";
export const OPTION_COUNTRYOPTIONS_MONACO =  "countryoptions-monaco";
export const OPTION_COUNTRYOPTIONS_MONGOLIA =  "countryoptions-mongolia";
export const OPTION_COUNTRYOPTIONS_MONTENEGRO =  "countryoptions-montenegro";
export const OPTION_COUNTRYOPTIONS_MONTSERRAT =  "countryoptions-montserrat";
export const OPTION_COUNTRYOPTIONS_MOROCCO =  "countryoptions-morocco";
export const OPTION_COUNTRYOPTIONS_MOZAMBIQUE =  "countryoptions-mozambique";
export const OPTION_COUNTRYOPTIONS_MYANMAR =  "countryoptions-myanmar";
export const OPTION_COUNTRYOPTIONS_NAMIBIA =  "countryoptions-namibia";
export const OPTION_COUNTRYOPTIONS_NAURU =  "countryoptions-nauru";
export const OPTION_COUNTRYOPTIONS_NEPAL =  "countryoptions-nepal";
export const OPTION_COUNTRYOPTIONS_NETHERLANDS =  "countryoptions-netherlands";
export const OPTION_COUNTRYOPTIONS_NEW_CALEDONIA =  "countryoptions-new-caledonia";
export const OPTION_COUNTRYOPTIONS_NEW_ZEALAND =  "countryoptions-new-zealand";
export const OPTION_COUNTRYOPTIONS_NICARAGUA =  "countryoptions-nicaragua";
export const OPTION_COUNTRYOPTIONS_NIGER =  "countryoptions-niger";
export const OPTION_COUNTRYOPTIONS_NIGERIA =  "countryoptions-nigeria";
export const OPTION_COUNTRYOPTIONS_NIUE =  "countryoptions-niue";
export const OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND =  "countryoptions-norfolk-island";
export const OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS =  "countryoptions-northern-mariana-islands";
export const OPTION_COUNTRYOPTIONS_NORWAY =  "countryoptions-norway";
export const OPTION_COUNTRYOPTIONS_OMAN =  "countryoptions-oman";
export const OPTION_COUNTRYOPTIONS_PAKISTAN =  "countryoptions-pakistan";
export const OPTION_COUNTRYOPTIONS_PALAU =  "countryoptions-palau";
export const OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED =  "countryoptions-palestinian-territory-occupied";
export const OPTION_COUNTRYOPTIONS_PANAMA =  "countryoptions-panama";
export const OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA =  "countryoptions-papua-new-guinea";
export const OPTION_COUNTRYOPTIONS_PARAGUAY =  "countryoptions-paraguay";
export const OPTION_COUNTRYOPTIONS_PERU =  "countryoptions-peru";
export const OPTION_COUNTRYOPTIONS_PHILIPPINES =  "countryoptions-philippines";
export const OPTION_COUNTRYOPTIONS_PITCAIRN =  "countryoptions-pitcairn";
export const OPTION_COUNTRYOPTIONS_POLAND =  "countryoptions-poland";
export const OPTION_COUNTRYOPTIONS_PORTUGAL =  "countryoptions-portugal";
export const OPTION_COUNTRYOPTIONS_PUERTO_RICO =  "countryoptions-puerto-rico";
export const OPTION_COUNTRYOPTIONS_QATAR =  "countryoptions-qatar";
export const OPTION_COUNTRYOPTIONS_RÉUNION =  "countryoptions-réunion";
export const OPTION_COUNTRYOPTIONS_ROMANIA =  "countryoptions-romania";
export const OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION =  "countryoptions-russian-federation";
export const OPTION_COUNTRYOPTIONS_RWANDA =  "countryoptions-rwanda";
export const OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY =  "countryoptions-saint-barthélemy";
export const OPTION_COUNTRYOPTIONS_SAINT_HELENA =  "countryoptions-saint-helena";
export const OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS =  "countryoptions-saint-kitts-and-nevis";
export const OPTION_COUNTRYOPTIONS_SAINT_LUCIA =  "countryoptions-saint-lucia";
export const OPTION_COUNTRYOPTIONS_SAINT_MARTIN =  "countryoptions-saint-martin";
export const OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON =  "countryoptions-saint-pierre-and-miquelon";
export const OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES =  "countryoptions-saint-vincent-and-the-grenadines";
export const OPTION_COUNTRYOPTIONS_SAMOA =  "countryoptions-samoa";
export const OPTION_COUNTRYOPTIONS_SAN_MARINO =  "countryoptions-san-marino";
export const OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE =  "countryoptions-sao-tome-and-principe";
export const OPTION_COUNTRYOPTIONS_SAUDI_ARABIA =  "countryoptions-saudi-arabia";
export const OPTION_COUNTRYOPTIONS_SENEGAL =  "countryoptions-senegal";
export const OPTION_COUNTRYOPTIONS_SERBIA =  "countryoptions-serbia";
export const OPTION_COUNTRYOPTIONS_SEYCHELLES =  "countryoptions-seychelles";
export const OPTION_COUNTRYOPTIONS_SIERRA_LEONE =  "countryoptions-sierra-leone";
export const OPTION_COUNTRYOPTIONS_SINGAPORE =  "countryoptions-singapore";
export const OPTION_COUNTRYOPTIONS_SLOVAKIA =  "countryoptions-slovakia";
export const OPTION_COUNTRYOPTIONS_SLOVENIA =  "countryoptions-slovenia";
export const OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS =  "countryoptions-solomon-islands";
export const OPTION_COUNTRYOPTIONS_SOMALIA =  "countryoptions-somalia";
export const OPTION_COUNTRYOPTIONS_SOUTH_AFRICA =  "countryoptions-south-africa";
export const OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS =  "countryoptions-south-georgia-and-the-south-sandwich-islands";
export const OPTION_COUNTRYOPTIONS_SPAIN =  "countryoptions-spain";
export const OPTION_COUNTRYOPTIONS_SRI_LANKA =  "countryoptions-sri-lanka";
export const OPTION_COUNTRYOPTIONS_SUDAN =  "countryoptions-sudan";
export const OPTION_COUNTRYOPTIONS_SURINAME =  "countryoptions-suriname";
export const OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN =  "countryoptions-svalbard-and-jan-mayen";
export const OPTION_COUNTRYOPTIONS_SWAZILAND =  "countryoptions-swaziland";
export const OPTION_COUNTRYOPTIONS_SWEDEN =  "countryoptions-sweden";
export const OPTION_COUNTRYOPTIONS_SWITZERLAND =  "countryoptions-switzerland";
export const OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC =  "countryoptions-syrian-arab-republic";
export const OPTION_COUNTRYOPTIONS_TAIWAN_ROC =  "countryoptions-taiwan-r.o.c.";
export const OPTION_COUNTRYOPTIONS_TAJIKISTAN =  "countryoptions-tajikistan";
export const OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF =  "countryoptions-tanzania-united-republic-of";
export const OPTION_COUNTRYOPTIONS_THAILAND =  "countryoptions-thailand";
export const OPTION_COUNTRYOPTIONS_TIMOR_LESTE =  "countryoptions-timor-leste";
export const OPTION_COUNTRYOPTIONS_TOGO =  "countryoptions-togo";
export const OPTION_COUNTRYOPTIONS_TOKELAU =  "countryoptions-tokelau";
export const OPTION_COUNTRYOPTIONS_TONGA =  "countryoptions-tonga";
export const OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO =  "countryoptions-trinidad-and-tobago";
export const OPTION_COUNTRYOPTIONS_TUNISIA =  "countryoptions-tunisia";
export const OPTION_COUNTRYOPTIONS_TURKEY =  "countryoptions-turkey";
export const OPTION_COUNTRYOPTIONS_TURKMENISTAN =  "countryoptions-turkmenistan";
export const OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS =  "countryoptions-turks-and-caicos-islands";
export const OPTION_COUNTRYOPTIONS_TUVALU =  "countryoptions-tuvalu";
export const OPTION_COUNTRYOPTIONS_UGANDA =  "countryoptions-uganda";
export const OPTION_COUNTRYOPTIONS_UKRAINE =  "countryoptions-ukraine";
export const OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES =  "countryoptions-united-arab-emirates";
export const OPTION_COUNTRYOPTIONS_UNITED_KINGDOM =  "countryoptions-united-kingdom";
export const OPTION_COUNTRYOPTIONS_UNITED_STATES =  "countryoptions-united-states";
export const OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS =  "countryoptions-united-states-minor-outlying-islands";
export const OPTION_COUNTRYOPTIONS_URUGUAY =  "countryoptions-uruguay";
export const OPTION_COUNTRYOPTIONS_UZBEKISTAN =  "countryoptions-uzbekistan";
export const OPTION_COUNTRYOPTIONS_VANUATU =  "countryoptions-vanuatu";
export const OPTION_COUNTRYOPTIONS_VENEZUELA =  "countryoptions-venezuela";
export const OPTION_COUNTRYOPTIONS_VIET_NAM =  "countryoptions-viet-nam";
export const OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH =  "countryoptions-virgin-islands-british";
export const OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US =  "countryoptions-virgin-islands-us";
export const OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA =  "countryoptions-wallis-and-futuna";
export const OPTION_COUNTRYOPTIONS_WESTERN_SAHARA =  "countryoptions-western-sahara";
export const OPTION_COUNTRYOPTIONS_YEMEN =  "countryoptions-yemen";
export const OPTION_COUNTRYOPTIONS_ZAMBIA =  "countryoptions-zambia";
export const OPTION_COUNTRYOPTIONS_ZIMBABWE =  "countryoptions-zimbabwe";

export const OPTION_DOESTHEPARTICULATEMATTER_NO = "doestheparticulatematter-no";
export const OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN = "doestheparticulatematter-unknown";
export const OPTION_DOESTHEPARTICULATEMATTER_YES = "doestheparticulatematter-yes";
export const I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE = "i-have-read-and-understand-the-linked-privacy-notice";
export const PRODUCT_LOT = "product-lot";
export const SHIPPING_DISTRIBUTION_LABEL = "shipping-distribution-label";
export const CARTON_LABEL = "carton-label";
export const INTERNAL_PRODUCT_LABEL = "internal-product-label";
export const TITLE_PD_RENAL = "pd-renal";
export const TITLE_SOLUTIONS = "solutions";
export const TITLE_ACCESS = "access";
export const TITLE_ALL_OTHER_PRODUCT = "all-other-product";
export const REPORTED_PROBLEM = "all-other-product";
export const LOGIN = "login";
export const SYSTEM_MENU = "system-menu";
export const INITIATE_PRODUCT_FEEDBACK = "initiate-product-feedback";
export const FEEDBACK_STATUS = "feedback-status";
export const OKTACALLBACK = "okta-callback";
export const VALID_EMAIL = "valid-email";
export const VALID_NUMERIC = "valid-numeric";
export const VALID_DATE = "valid-date";
export const PLEASE_UPLOAD_IMAGE = "please-upload-image";
export const LOT_SERIAL_NO = "Lot /Serial No";
export const QUANTITY = "quantity";
export const EDIT = "edit";
export const DELETE = "delete";
export const LOT_NUMBER_NOT_FOUND = "lot-number-not-found";
export const SEARCHING_LOT_NUMBER = "searching-lot-number";
export const PRODUCT_CODE_NOT_FOUND = "product-code-not-found";
export const SEARCHING_PRODUCT_CODE = "searching-product-code";
export const FILE_OF_TYPES_ARE_NOT_ALLOWED = "file-of-types-are-not-allowed";
export const THE_FILE_YOU_ARE_ATTEMPTING = "the-file-you-are-attempting";
export const IMAGE_ICON = "click-on-the-image-icon-to-select-the-option";
export const LOGIN_TO_ACCOUNT = "login-to-account";
export const SIGN_IN_TO_YOUR_ACCOUNT = "sign-in-to-your-account";
export const PASSWORD = "password";
export const SIGN_IN = "sign-in";
export const UNKNOWN = "unknown";
export const ASKED_UNKNOWN = "asked unknown";
export const DD = "dd";
export const MMM = "mmm";
export const YYYY = "yyyy";
export const DD_MMM_YYYY = "dd-mmm-yyyy";
export const SELECT_COUNTRY = "select-country";
export const CHINESE_SIMPLIFIED_CHINESE = "chinese-simplified-chinese";
export const DUTCH = "dutch";
export const ENGLISH = "english";
export const FRENCH = "french";
export const GERMAN = "german";
export const ITALIAN = "italian";
export const JAPANESE = "japanese";
export const KOREAN = "korean";
export const MANDARIN_TRADITIONAL_CHINESE = "mandarin-traditional-chinese";
export const POLISH = "polish";
export const PORTUGUESE = "portuguese";
export const SPANISH = "spanish";
export const THAI = "thai";
export const TURKISH = "turkish";
export const VIETNAMESE = "vietnamese";
export const BROWSE = "browse";
export const CLOSE = "Close";
export const FEEDBACK_SUBMITTED = "feedback-submitted";
export const YOUR_PRODUCT_EXPERIENCE_FEEDBACK = "your-product-experience-feedback";
export const IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION= "if-you-have-questions-or-additional-information";
export const PATIENT_AGE = "patient-age";
export const ENTER_AGE = "enter-age";
export const PATIENT_DOB = "patient-dob";
export const RELEVANT_ATTACHMENTS = "relevant-attachments";
export const VANTIVE_ACCOUNT_CREDENTIALS = "vantive-account-credentials";
export const GET_PRODUCT_DETAILS = "get-product-details";
export const USE_THE_DIAGRAM_ABOVE_FIGURE_2 = "use-the-diagram-above-figure-2";
export const FACILITY_ADDRESS = "facility-address";
export const LABEL_ANOTHER_FACILITY_ADDRESS = "label-another-facility-address";
export const CHOOSE_PRODUCT_CODE = "choose-product-code";
export const USE_THE_DIAGRAM_ABOVE_FIGURE_3 = "use-the-diagram-above-figure-3";
export const DECLINE = "decline";
export const OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA = "bonaire-sint-eustatius-and-saba";
export const OPTION_COUNTRYOPTIONS_CURAÇAO = "curaçao";
export const OPTION_COUNTRYOPTIONS_SOUTH_SUDAN = "south-sudan";
export const OPTION_COUNTRYOPTIONS_ESWATINI = "eswatini";

export const FORM_HELP_TEXT = "indicates-help-text-is-available-for-this-field";

export const YOUR_FIRST_NAME = "your-first-name";
export const YOUR_LAST_NAME = "your-last-name";
export const MY_FIRST_NAME = "my-first-name";
export const MY_LAST_NAME = "my-last-name";
export const PATIENT_FIRST_NAME = "patient-first-name";
export const PATIENT_LAST_NAME = "patient-last-name";
export const REPORTER_FIRST_NAME = "reporter-first-name";
export const REPORTER_LAST_NAME = "reporter-last-name";
export const EMPLOYEE_FIRST_NAME = "employee-first-name";
export const EMPLOYEE_LAST_NAME = "employee-last-name";
export const END_USER_CUSTOMER_FIRST_NAME = "end-user-customer-contact-first-name";
export const END_USER_CUSTOMER_LAST_NAME = "end-user-customer-contact-last-name";
export const ADDITIONAL_CONTACT_FIRST_NAME = "additional-contact-first-name";
export const ADDITIONAL_CONTACT_LAST_NAME = "additional-contact-last-name";

export const COPYRIGHT_VANTIVE = "vantive";
export const COPYRIGHT_VERSION = "all-rights-reserved-version";

export const ADD_ADDITIONAL_CONTACT = "add-additional-contact";
export const CONTACT_ME = "customer-does-not-wish";
export const DO_NOT_CONTACT = "do-not-contact";
export const END_USER_CUSTOMER_FACILITY_NAME = "end-user-customer-facility-name";
export const END_USER_CUSTOMER_PHONE = "end-user-customer-facility-phone-number";
export const END_USER_CUSTOMER_EMAIL = "end-user-customer-email-address";
export const END_USER_CUSTOMER_FACILITY_ADDRESS = "end-user-customer-facility-address";

export const SAME_AS_PATIENT_ADDRESS = "same-as-patient-address";
export const SAME_AS_REPORTER_ADDRESS = "same-as-reporter-address";
export const SAME_AS_END_USER_CUSTOMER_ADDRESS = "same-as-end-user-customer-address";
export const CONTACT_US = "contact-us";
export const LANDING_BRIEF_FOR_DEVICE = 'landing-brief-for-device';
export const PATIENT_SEX = 'patient-sex';
export const OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY = 'cisgender-man-boy';
export const OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL = 'cisgender-woman-girl';
export const OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM = 'transgender-man-trans-man-female-to-male-FTM';
export const OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF = 'transgender-woman-trans-woman-male-to-female-MTF';
export const OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY = 'other-gender-category-please-specify';
export const OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER = 'decline-to-answer';

export const ATTENTION_NEEDED = "attention-needed";
export const SUBMIT_ERR_MSG = "submit-err-msg";
export const SUBMIT_RETRY_MSG = "submit-retry-msg";
export const OK = "ok";